function getCookieDnt(cname) {
  let name = cname + "=";
  let ca = document.cookie.split(';');
  for(let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

var privacyBanner = function(e) {
    "use strict";
  let regionCheck = getCookieDnt("_tracking_consent");
  console.log("regCheck", JSON.parse(decodeURIComponent(regionCheck)))
  const regCheck = JSON.parse(decodeURIComponent(regionCheck)).reg
  console.log("test", JSON.parse(decodeURIComponent(regionCheck)).reg)
  
  if(regCheck !== "GDPR") {
    var n = function(e, t) {
        return n = Object.setPrototypeOf || {
            __proto__: []
        } instanceof Array && function(e, n) {
            e.__proto__ = n
        } || function(e, n) {
            for (var t in n)
                Object.prototype.hasOwnProperty.call(n, t) && (e[t] = n[t])
        }, n(e, t)
    };
    function t(e, t) {
        if ("function" != typeof t && null !== t)
            throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
        function o() {
            this.constructor = e
        }
        n(e, t),
        e.prototype = null === t ? Object.create(t) : (o.prototype = t.prototype, new o)
    }
    var o = function() {
        return o = Object.assign || function(e) {
            for (var n, t = 1, o = arguments.length; t < o; t++)
                for (var r in n = arguments[t])
                    Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
            return e
        }, o.apply(this, arguments)
    };
    function r(e, n) {
        var t = {};
        for (var o in e)
            Object.prototype.hasOwnProperty.call(e, o) && n.indexOf(o) < 0 && (t[o] = e[o]);
        if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
            var r = 0;
            for (o = Object.getOwnPropertySymbols(e); r < o.length; r++)
                n.indexOf(o[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[r]) && (t[o[r]] = e[o[r]])
        }
        return t
    }
    function a(e, n, t, o) {
        var r,
            a = arguments.length,
            i = a < 3 ? n : null === o ? o = Object.getOwnPropertyDescriptor(n, t) : o;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate)
            i = Reflect.decorate(e, n, t, o);
        else
            for (var c = e.length - 1; c >= 0; c--)
                (r = e[c]) && (i = (a < 3 ? r(i) : a > 3 ? r(n, t, i) : r(n, t)) || i);
        return a > 3 && i && Object.defineProperty(n, t, i), i
    }
    function i(e, n) {
        return function(t, o) {
            n(t, o, e)
        }
    }
    function c(e, n) {
        if ("object" == typeof Reflect && "function" == typeof Reflect.metadata)
            return Reflect.metadata(e, n)
    }
    function s(e, n, t, o) {
        return new (t || (t = Promise))((function(r, a) {
            function i(e) {
                try {
                    s(o.next(e))
                } catch (e) {
                    a(e)
                }
            }
            function c(e) {
                try {
                    s(o.throw(e))
                } catch (e) {
                    a(e)
                }
            }
            function s(e) {
                var n;
                e.done ? r(e.value) : (n = e.value, n instanceof t ? n : new t((function(e) {
                    e(n)
                }))).then(i, c)
            }
            s((o = o.apply(e, n || [])).next())
        }))
    }
    function l(e, n) {
        var t,
            o,
            r,
            a,
            i = {
                label: 0,
                sent: function() {
                    if (1 & r[0])
                        throw r[1];
                    return r[1]
                },
                trys: [],
                ops: []
            };
        return a = {
            next: c(0),
            throw: c(1),
            return: c(2)
        }, "function" == typeof Symbol && (a[Symbol.iterator] = function() {
            return this
        }), a;
        function c(c) {
            return function(s) {
                return function(c) {
                    if (t)
                        throw new TypeError("Generator is already executing.");
                    for (; a && (a = 0, c[0] && (i = 0)), i;)
                        try {
                            if (t = 1, o && (r = 2 & c[0] ? o.return : c[0] ? o.throw || ((r = o.return) && r.call(o), 0) : o.next) && !(r = r.call(o, c[1])).done)
                                return r;
                            switch (o = 0, r && (c = [2 & c[0], r.value]), c[0]) {
                            case 0:
                            case 1:
                                r = c;
                                break;
                            case 4:
                                return i.label++, {
                                    value: c[1],
                                    done: !1
                                };
                            case 5:
                                i.label++,
                                o = c[1],
                                c = [0];
                                continue;
                            case 7:
                                c = i.ops.pop(),
                                i.trys.pop();
                                continue;
                            default:
                                if (!(r = i.trys, (r = r.length > 0 && r[r.length - 1]) || 6 !== c[0] && 2 !== c[0])) {
                                    i = 0;
                                    continue
                                }
                                if (3 === c[0] && (!r || c[1] > r[0] && c[1] < r[3])) {
                                    i.label = c[1];
                                    break
                                }
                                if (6 === c[0] && i.label < r[1]) {
                                    i.label = r[1],
                                    r = c;
                                    break
                                }
                                if (r && i.label < r[2]) {
                                    i.label = r[2],
                                    i.ops.push(c);
                                    break
                                }
                                r[2] && i.ops.pop(),
                                i.trys.pop();
                                continue
                            }
                            c = n.call(e, i)
                        } catch (e) {
                            c = [6, e],
                            o = 0
                        } finally {
                            t = r = 0
                        }
                    if (5 & c[0])
                        throw c[1];
                    return {
                        value: c[0] ? c[1] : void 0,
                        done: !0
                    }
                }([c, s])
            }
        }
    }
    var u = Object.create ? function(e, n, t, o) {
        void 0 === o && (o = t);
        var r = Object.getOwnPropertyDescriptor(n, t);
        r && !("get" in r ? !n.__esModule : r.writable || r.configurable) || (r = {
            enumerable: !0,
            get: function() {
                return n[t]
            }
        }),
        Object.defineProperty(e, o, r)
    } : function(e, n, t, o) {
        void 0 === o && (o = t),
        e[o] = n[t]
    };
    function d(e, n) {
        for (var t in e)
            "default" === t || Object.prototype.hasOwnProperty.call(n, t) || u(n, e, t)
    }
    function p(e) {
        var n = "function" == typeof Symbol && Symbol.iterator,
            t = n && e[n],
            o = 0;
        if (t)
            return t.call(e);
        if (e && "number" == typeof e.length)
            return {
                next: function() {
                    return e && o >= e.length && (e = void 0), {
                        value: e && e[o++],
                        done: !e
                    }
                }
            };
        throw new TypeError(n ? "Object is not iterable." : "Symbol.iterator is not defined.")
    }
    function f(e, n) {
        var t = "function" == typeof Symbol && e[Symbol.iterator];
        if (!t)
            return e;
        var o,
            r,
            a = t.call(e),
            i = [];
        try {
            for (; (void 0 === n || n-- > 0) && !(o = a.next()).done;)
                i.push(o.value)
        } catch (e) {
            r = {
                error: e
            }
        } finally {
            try {
                o && !o.done && (t = a.return) && t.call(a)
            } finally {
                if (r)
                    throw r.error
            }
        }
        return i
    }
    function h() {
        for (var e = [], n = 0; n < arguments.length; n++)
            e = e.concat(f(arguments[n]));
        return e
    }
    function y() {
        for (var e = 0, n = 0, t = arguments.length; n < t; n++)
            e += arguments[n].length;
        var o = Array(e),
            r = 0;
        for (n = 0; n < t; n++)
            for (var a = arguments[n], i = 0, c = a.length; i < c; i++, r++)
                o[r] = a[i];
        return o
    }
    function m(e, n, t) {
        if (t || 2 === arguments.length)
            for (var o, r = 0, a = n.length; r < a; r++)
                !o && r in n || (o || (o = Array.prototype.slice.call(n, 0, r)), o[r] = n[r]);
        return e.concat(o || Array.prototype.slice.call(n))
    }
    function g(e) {
        return this instanceof g ? (this.v = e, this) : new g(e)
    }
    function v(e, n, t) {
        if (!Symbol.asyncIterator)
            throw new TypeError("Symbol.asyncIterator is not defined.");
        var o,
            r = t.apply(e, n || []),
            a = [];
        return o = {}, i("next"), i("throw"), i("return"), o[Symbol.asyncIterator] = function() {
            return this
        }, o;
        function i(e) {
            r[e] && (o[e] = function(n) {
                return new Promise((function(t, o) {
                    a.push([e, n, t, o]) > 1 || c(e, n)
                }))
            })
        }
        function c(e, n) {
            try {
                (t = r[e](n)).value instanceof g ? Promise.resolve(t.value.v).then(s, l) : u(a[0][2], t)
            } catch (e) {
                u(a[0][3], e)
            }
            var t
        }
        function s(e) {
            c("next", e)
        }
        function l(e) {
            c("throw", e)
        }
        function u(e, n) {
            e(n),
            a.shift(),
            a.length && c(a[0][0], a[0][1])
        }
    }
    function C(e) {
        var n,
            t;
        return n = {}, o("next"), o("throw", (function(e) {
            throw e
        })), o("return"), n[Symbol.iterator] = function() {
            return this
        }, n;
        function o(o, r) {
            n[o] = e[o] ? function(n) {
                return (t = !t) ? {
                    value: g(e[o](n)),
                    done: !1
                } : r ? r(n) : n
            } : r
        }
    }
    function b(e) {
        if (!Symbol.asyncIterator)
            throw new TypeError("Symbol.asyncIterator is not defined.");
        var n,
            t = e[Symbol.asyncIterator];
        return t ? t.call(e) : (e = p(e), n = {}, o("next"), o("throw"), o("return"), n[Symbol.asyncIterator] = function() {
            return this
        }, n);
        function o(t) {
            n[t] = e[t] && function(n) {
                return new Promise((function(o, r) {
                    (function(e, n, t, o) {
                        Promise.resolve(o).then((function(n) {
                            e({
                                value: n,
                                done: t
                            })
                        }), n)
                    })(o, r, (n = e[t](n)).done, n.value)
                }))
            }
        }
    }
    function _(e, n) {
        return Object.defineProperty ? Object.defineProperty(e, "raw", {
            value: n
        }) : e.raw = n, e
    }
    var E = Object.create ? function(e, n) {
        Object.defineProperty(e, "default", {
            enumerable: !0,
            value: n
        })
    } : function(e, n) {
        e.default = n
    };
    function w(e) {
        if (e && e.__esModule)
            return e;
        var n = {};
        if (null != e)
            for (var t in e)
                "default" !== t && Object.prototype.hasOwnProperty.call(e, t) && u(n, e, t);
        return E(n, e), n
    }
    function A(e) {
        return e && e.__esModule ? e : {
            default: e
        }
    }
    function D(e, n, t, o) {
        if ("a" === t && !o)
            throw new TypeError("Private accessor was defined without a getter");
        if ("function" == typeof n ? e !== n || !o : !n.has(e))
            throw new TypeError("Cannot read private member from an object whose class did not declare it");
        return "m" === t ? o : "a" === t ? o.call(e) : o ? o.value : n.get(e)
    }
    function x(e, n, t, o, r) {
        if ("m" === o)
            throw new TypeError("Private method is not writable");
        if ("a" === o && !r)
            throw new TypeError("Private accessor was defined without a setter");
        if ("function" == typeof n ? e !== n || !r : !n.has(e))
            throw new TypeError("Cannot write private member to an object whose class did not declare it");
        return "a" === o ? r.call(e, t) : r ? r.value = t : n.set(e, t), t
    }
    function I(e, n) {
        if (null === n || "object" != typeof n && "function" != typeof n)
            throw new TypeError("Cannot use 'in' operator on non-object");
        return "function" == typeof e ? n === e : e.has(n)
    }
    function O(e, n, t) {
        if (null != n) {
            if ("object" != typeof n && "function" != typeof n)
                throw new TypeError("Object expected.");
            var o;
            if (t) {
                if (!Symbol.asyncDispose)
                    throw new TypeError("Symbol.asyncDispose is not defined.");
                o = n[Symbol.asyncDispose]
            }
            if (void 0 === o) {
                if (!Symbol.dispose)
                    throw new TypeError("Symbol.dispose is not defined.");
                o = n[Symbol.dispose]
            }
            if ("function" != typeof o)
                throw new TypeError("Object not disposable.");
            e.stack.push({
                value: n,
                dispose: o,
                async: t
            })
        } else
            t && e.stack.push({
                async: !0
            });
        return n
    }
    var T = "function" == typeof SuppressedError ? SuppressedError : function(e, n, t) {
        var o = new Error(t);
        return o.name = "SuppressedError", o.error = e, o.suppressed = n, o
    };
    function P(e) {
        function n(n) {
            e.error = e.hasError ? new T(n, e.error, "An error was suppressed during disposal.") : n,
            e.hasError = !0
        }
        return function t() {
            for (; e.stack.length;) {
                var o = e.stack.pop();
                try {
                    var r = o.dispose && o.dispose.call(o.value);
                    if (o.async)
                        return Promise.resolve(r).then(t, (function(e) {
                            return n(e), t()
                        }))
                } catch (e) {
                    n(e)
                }
            }
            if (e.hasError)
                throw e.error
        }()
    }
    var k = {
            __extends: t,
            __assign: o,
            __rest: r,
            __decorate: a,
            __param: i,
            __metadata: c,
            __awaiter: s,
            __generator: l,
            __createBinding: u,
            __exportStar: d,
            __values: p,
            __read: f,
            __spread: h,
            __spreadArrays: y,
            __spreadArray: m,
            __await: g,
            __asyncGenerator: v,
            __asyncDelegator: C,
            __asyncValues: b,
            __makeTemplateObject: _,
            __importStar: w,
            __importDefault: A,
            __classPrivateFieldGet: D,
            __classPrivateFieldSet: x,
            __classPrivateFieldIn: I,
            __addDisposableResource: O,
            __disposeResources: P
        },
        S = Object.freeze({
            __proto__: null,
            __addDisposableResource: O,
            get __assign() {
                return o
            },
            __asyncDelegator: C,
            __asyncGenerator: v,
            __asyncValues: b,
            __await: g,
            __awaiter: s,
            __classPrivateFieldGet: D,
            __classPrivateFieldIn: I,
            __classPrivateFieldSet: x,
            __createBinding: u,
            __decorate: a,
            __disposeResources: P,
            __esDecorate: function(e, n, t, o, r, a) {
                function i(e) {
                    if (void 0 !== e && "function" != typeof e)
                        throw new TypeError("Function expected");
                    return e
                }
                for (var c, s = o.kind, l = "getter" === s ? "get" : "setter" === s ? "set" : "value", u = !n && e ? o.static ? e : e.prototype : null, d = n || (u ? Object.getOwnPropertyDescriptor(u, o.name) : {}), p = !1, f = t.length - 1; f >= 0; f--) {
                    var h = {};
                    for (var y in o)
                        h[y] = "access" === y ? {} : o[y];
                    for (var y in o.access)
                        h.access[y] = o.access[y];
                    h.addInitializer = function(e) {
                        if (p)
                            throw new TypeError("Cannot add initializers after decoration has completed");
                        a.push(i(e || null))
                    };
                    var m = (0, t[f])("accessor" === s ? {
                        get: d.get,
                        set: d.set
                    } : d[l], h);
                    if ("accessor" === s) {
                        if (void 0 === m)
                            continue;
                        if (null === m || "object" != typeof m)
                            throw new TypeError("Object expected");
                        (c = i(m.get)) && (d.get = c),
                        (c = i(m.set)) && (d.set = c),
                        (c = i(m.init)) && r.unshift(c)
                    } else
                        (c = i(m)) && ("field" === s ? r.unshift(c) : d[l] = c)
                }
                u && Object.defineProperty(u, o.name, d),
                p = !0
            },
            __exportStar: d,
            __extends: t,
            __generator: l,
            __importDefault: A,
            __importStar: w,
            __makeTemplateObject: _,
            __metadata: c,
            __param: i,
            __propKey: function(e) {
                return "symbol" == typeof e ? e : "".concat(e)
            },
            __read: f,
            __rest: r,
            __runInitializers: function(e, n, t) {
                for (var o = arguments.length > 2, r = 0; r < n.length; r++)
                    t = o ? n[r].call(e, t) : n[r].call(e);
                return o ? t : void 0
            },
            __setFunctionName: function(e, n, t) {
                return "symbol" == typeof n && (n = n.description ? "[".concat(n.description, "]") : ""), Object.defineProperty(e, "name", {
                    configurable: !0,
                    value: t ? "".concat(t, " ", n) : n
                })
            },
            __spread: h,
            __spreadArray: m,
            __spreadArrays: y,
            __values: p,
            default: k
        });
    let R;
    !function(e) {
        e.TRACKING_ACCEPTED = "trackingConsentAccepted",
        e.TRACKING_DECLINED = "trackingConsentDeclined",
        e.MARKETING_ACCEPTED = "firstPartyMarketingConsentAccepted",
        e.SALE_OF_DATA_ACCEPTED = "thirdPartyMarketingConsentAccepted",
        e.ANALYTICS_ACCEPTED = "analyticsConsentAccepted",
        e.PREFERENCES_ACCEPTED = "preferencesConsentAccepted",
        e.MARKETING_DECLINED = "firstPartyMarketingConsentDeclined",
        e.SALE_OF_DATA_DECLINED = "thirdPartyMarketingConsentDeclined",
        e.ANALYTICS_DECLINED = "analyticsConsentDeclined",
        e.PREFERENCES_DECLINED = "preferencesConsentDeclined",
        e.CONSENT_COLLECTED = "visitorConsentCollected",
        e.CONSENT_TRACKING_API_LOADED = "consentTrackingApiLoaded"
    }(R || (R = {}));
    const N = "2.1";
    let M,
        L,
        B,
        j,
        U,
        H,
        F,
        G;
    !function(e) {
        e.ACCEPTED = "yes",
        e.DECLINED = "no",
        e.NO_INTERACTION = "no_interaction",
        e.NO_VALUE = ""
    }(M || (M = {})),
    function(e) {
        e.NO_VALUE = "",
        e.ACCEPTED = "1",
        e.DECLINED = "0"
    }(L || (L = {})),
    function(e) {
        e.GDPR = "GDPR",
        e.CCPA = "CCPA",
        e.NO_VALUE = ""
    }(B || (B = {})),
    function(e) {
        e.PREFERENCES = "p",
        e.ANALYTICS = "a",
        e.MARKETING = "m",
        e.SALE_OF_DATA = "t"
    }(j || (j = {})),
    function(e) {
        e.GDPR = "GDPR",
        e.GDPR_BLOCK_ALL = "GDPR_BLOCK_ALL",
        e.CCPA = "CCPA"
    }(U || (U = {})),
    function(e) {
        e.MARKETING = "m",
        e.ANALYTICS = "a",
        e.PREFERENCES = "p",
        e.SALE_OF_DATA = "s"
    }(H || (H = {})),
    function(e) {
        e.MARKETING = "marketing",
        e.ANALYTICS = "analytics",
        e.PREFERENCES = "preferences",
        e.SALE_OF_DATA = "sale_of_data",
        e.EMAIL = "email"
    }(F || (F = {})),
    function(e) {
        e.HEADLESS_STOREFRONT = "headlessStorefront",
        e.ROOT_DOMAIN = "rootDomain",
        e.CHECKOUT_ROOT_DOMAIN = "checkoutRootDomain",
        e.STOREFRONT_ROOT_DOMAIN = "storefrontRootDomain",
        e.STOREFRONT_ACCESS_TOKEN = "storefrontAccessToken"
    }(G || (G = {}));
    const K = ["lim", "v", "con", "reg"];
    let W = {};
    function V(e) {
        let n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
        return e in W || function(e) {
            const n = document.cookie ? document.cookie.split("; ") : [];
            W[e] = void 0;
            for (let t = 0; t < n.length; t++) {
                const [o, r] = n[t].split("=");
                if (e === decodeURIComponent(o))
                    return W[e] = JSON.parse(decodeURIComponent(r)), W[e]
            }
        }(e) || function(e, n) {
            if (null === n)
                return;
            W[e] = void 0;
            let t,
                o,
                r = document.head.querySelector("meta[name=".concat(n, "]"));
            if (r instanceof HTMLMetaElement) {
                t = r.content;
                try {
                    const e = t.replace(/1/g, "true").replace(/0/g, "false").split(";").map((e => e.trim())).map((e => e.split("=").map((e => e.trim()))));
                    if (o = Object.fromEntries(e), o.purposes) {
                        const e = o.purposes.split(/(true|false)/).filter(Boolean),
                            n = {};
                        for (let t = 0; t < e.length; t += 2)
                            n[e[t]] = JSON.parse(e[t + 1]);
                        o.purposes = n
                    }
                    for (let [e, n] of Object.entries(o))
                        "true" === n && (o[e] = !0),
                        "false" === n && (o[e] = !1)
                } catch (e) {
                    return
                }
                W[e] = o
            }
        }(e, n), W[e]
    }
    function q(e) {
        return e === encodeURIComponent(decodeURIComponent(e))
    }
    function z(e, n, t, o) {
        if (!q(o))
            throw new TypeError("Cookie value is not correctly URI encoded.");
        if (!q(e))
            throw new TypeError("Cookie name is not correctly URI encoded.");
        let r = "".concat(e, "=").concat(o);
        r += "; path=/",
        r += "; domain=".concat(n),
        r += "; expires=".concat(new Date((new Date).getTime() + t).toUTCString()),
        r += "; secure",
        document.cookie = r,
        W[e] = JSON.parse(decodeURIComponent(o))
    }
    function Y(e, n) {
        var t = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var o = Object.getOwnPropertySymbols(e);
            n && (o = o.filter((function(n) {
                return Object.getOwnPropertyDescriptor(e, n).enumerable
            }))),
            t.push.apply(t, o)
        }
        return t
    }
    function J(e) {
        for (var n = 1; n < arguments.length; n++) {
            var t = null != arguments[n] ? arguments[n] : {};
            n % 2 ? Y(Object(t), !0).forEach((function(n) {
                X(e, n, t[n])
            })) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Y(Object(t)).forEach((function(n) {
                Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n))
            }))
        }
        return e
    }
    function X(e, n, t) {
        return n in e ? Object.defineProperty(e, n, {
            value: t,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[n] = t, e
    }
    const Z = "_tracking_consent";
    function Q() {
        const e = V(Z);
        if (void 0 !== e && !function(e) {
            if (e.v !== N)
                return !0;
            return !function(e, n) {
                const t = n.slice().sort();
                return e.length === n.length && e.slice().sort().every(((e, n) => e === t[n]))
            }(Object.keys(e).filter((e => "region" !== e)), K)
        }(e))
            return e
    }
    function $() {
        try {
            let e = Q();
            if (!e)
                return;
            return e
        } catch (e) {
            return
        }
    }
    function ee() {
        return {
            m: ae(H.MARKETING),
            a: ae(H.ANALYTICS),
            p: ae(H.PREFERENCES),
            s: ae(H.SALE_OF_DATA)
        }
    }
    function ne() {
        return ee()[H.SALE_OF_DATA]
    }
    function te() {
        let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null;
        return null === e && (e = $()), void 0 === e
    }
    function oe(e) {
        switch (e) {
        case L.ACCEPTED:
            return M.ACCEPTED;
        case L.DECLINED:
            return M.DECLINED;
        default:
            return M.NO_VALUE
        }
    }
    function re(e) {
        switch (e) {
        case H.ANALYTICS:
            return F.ANALYTICS;
        case H.MARKETING:
            return F.MARKETING;
        case H.PREFERENCES:
            return F.PREFERENCES;
        case H.SALE_OF_DATA:
            return F.SALE_OF_DATA
        }
    }
    function ae(e) {
        const n = $();
        if (!n)
            return L.NO_VALUE;
        const t = n.con.CMP;
        return t ? t[e] : L.NO_VALUE
    }
    const ie = "_cmp_a",
        ce = "shopify-cmp-metadata";
    function se() {
        return V(ie, ce)
    }
    function le(e) {
        const n = se();
        if (!n)
            return !0;
        const t = n.purposes[e];
        return "boolean" != typeof t || t
    }
    function ue() {
        return le(j.PREFERENCES)
    }
    function de() {
        return le(j.ANALYTICS)
    }
    function pe() {
        return le(j.MARKETING)
    }
    function fe() {
        return le(j.SALE_OF_DATA)
    }
    const he = {
        "": [],
        GDPR: [U.GDPR, U.GDPR_BLOCK_ALL],
        CCPA: [U.CCPA]
    };
    function ye(e) {
        void 0 !== e.consent ? ge({
            [j.PREFERENCES]: e.consent,
            [j.ANALYTICS]: e.consent,
            [j.MARKETING]: e.consent,
            [j.SALE_OF_DATA]: e.consent
        }) : void 0 !== e.granular_consent && ge({
            [j.PREFERENCES]: ue(),
            [j.ANALYTICS]: de(),
            [j.MARKETING]: pe(),
            [j.SALE_OF_DATA]: fe()
        })
    }
    function me(e, n) {
        document.dispatchEvent(new CustomEvent(e, {
            detail: n || {}
        }))
    }
    function ge(e) {
        const n = e[j.MARKETING],
            t = e[j.SALE_OF_DATA],
            o = e[j.ANALYTICS],
            r = e[j.PREFERENCES];
        !0 === n ? me(R.MARKETING_ACCEPTED) : !1 === n && me(R.MARKETING_DECLINED),
        !0 === t ? me(R.SALE_OF_DATA_ACCEPTED) : !1 === t && me(R.SALE_OF_DATA_DECLINED),
        !0 === o ? me(R.ANALYTICS_ACCEPTED) : !1 === o && me(R.ANALYTICS_DECLINED),
        !0 === r ? me(R.PREFERENCES_ACCEPTED) : !1 === r && me(R.PREFERENCES_DECLINED);
        const a = function(e) {
            const n = {
                marketingAllowed: e[j.MARKETING],
                saleOfDataAllowed: e[j.SALE_OF_DATA],
                analyticsAllowed: e[j.ANALYTICS],
                preferencesAllowed: e[j.PREFERENCES],
                firstPartyMarketingAllowed: e[j.MARKETING],
                thirdPartyMarketingAllowed: e[j.SALE_OF_DATA]
            };
            return n
        }(e);
        me(R.CONSENT_COLLECTED, a);
        const i = [o, r, n, t];
        i.every((e => !0 === e)) && me(R.TRACKING_ACCEPTED),
        i.every((e => !1 === e)) && me(R.TRACKING_DECLINED)
    }
    const ve = 4;
    function Ce(e, n) {
        const t = new XMLHttpRequest,
            o = JSON.stringify(e);
        t.open("POST", "/set_tracking_consent.json", !0),
        t.setRequestHeader("Content-Type", "application/json"),
        t.onreadystatechange = function() {
            if (t.readyState !== ve)
                return;
            W = {};
            const o = function(e) {
                try {
                    return JSON.parse(e)
                } catch (e) {
                    return {
                        error: "Unknown error"
                    }
                }
            }(t.responseText);
            var r;
            0 === (r = t.status) || 200 >= r && r < 400 ? (ye(e), n(null, o)) : n(o)
        },
        t.send(o)
    }
    function be(e) {
        const n = JSON.stringify({
            marketing: e.marketing,
            analytics: e.analytics,
            preferences: e.preferences,
            saleOfData: e.sale_of_data
        }).replace(/"/g, "");
        return {
            query: "query { consentManagement { cookies(visitorConsent: ".concat(n, ") { answersCookie trackingConsentCookie } } }"),
            variables: {}
        }
    }
    function _e(e, n) {
        const t = e.granular_consent,
            o = {
                headers: {
                    "content-type": "application/json",
                    "x-shopify-storefront-access-token": t.storefrontAccessToken
                },
                body: JSON.stringify(be(t)),
                method: "POST"
            };
        fetch("https://".concat(t.checkoutRootDomain, "/api/unstable/graphql.json"), o).then((e => {
            if (e.ok)
                return e.json();
            throw new Error("Server error")
        })).then((o => {
            const r = 31536e6,
                a = "." + (t.checkoutRootDomain || window.location.hostname),
                i = "." + (t.storefrontRootDomain || window.location.hostname),
                c = o.data.consentManagement.cookies.trackingConsentCookie,
                s = o.data.consentManagement.cookies.answersCookie;
            z(Z, a, r, c),
            z(ie, a, r, s),
            i !== a && (z(Z, i, r, c), z(ie, i, r, s)),
            ye(e),
            n(null, o)
        })).catch((e => {
            n({
                error: "Error while setting headless consent: " + e.message
            })
        }))
    }
    function Ee() {
        if (te())
            return M.NO_VALUE;
        const e = ee();
        return e[H.MARKETING] === L.ACCEPTED && e[H.ANALYTICS] === L.ACCEPTED ? M.ACCEPTED : e[H.MARKETING] === L.DECLINED || e[H.ANALYTICS] === L.DECLINED ? M.DECLINED : M.NO_INTERACTION
    }
    function we() {
        const e = function() {
            const e = $();
            return te(e) ? B.NO_VALUE : e.reg
        }();
        return e in B ? e : B.NO_VALUE
    }
    function Ae() {
        return function() {
            const e = $();
            return te(e) ? {
                limit: []
            } : {
                limit: e.lim
            }
        }()
    }
    function De(e) {
        return ke(U.GDPR_BLOCK_ALL) && e ? Ie() ? document.referrer : "" : null
    }
    function xe(e) {
        return ke(U.GDPR_BLOCK_ALL) && e ? Ie() ? window.location.pathname + window.location.search : "/" : null
    }
    function Ie() {
        if ("" === document.referrer)
            return !0;
        const e = document.createElement("a");
        return e.href = document.referrer, window.location.hostname != e.hostname
    }
    function Oe() {
        if (!ke(U.GDPR) && !ke(U.GDPR_BLOCK_ALL))
            return !0;
        const e = ee();
        if (e[H.MARKETING] === L.ACCEPTED && e[H.ANALYTICS] === L.ACCEPTED)
            return !0;
        if (e[H.MARKETING] === L.DECLINED || e[H.ANALYTICS] === L.DECLINED)
            return !1;
        return we() !== B.GDPR
    }
    function Te() {
        const e = we();
        if (e === B.NO_VALUE)
            return !1;
        const n = Ae();
        return 0 !== n.limit.length && n.limit.some((n => function(e, n) {
                return he[e].includes(n)
            }(e, n)))
    }
    function Pe() {
        return !!te() || Oe()
    }
    function ke(e) {
        return Ae().limit.includes(e)
    }
    function Se() {
        return we() !== B.CCPA ? null : ke(U.CCPA) ? "string" == typeof navigator.globalPrivacyControl ? "1" !== navigator.globalPrivacyControl : "boolean" == typeof navigator.globalPrivacyControl ? !navigator.globalPrivacyControl : null : null
    }
    function Re() {
        return !1 === Se() ? M.DECLINED : (e = ne(), te() ? M.NO_VALUE : e === L.NO_VALUE ? M.NO_INTERACTION : oe(e));
        var e
    }
    const Ne = {
            getTrackingConsent: Ee,
            setTrackingConsent: function(e, n) {
                if (te() && console.warn("Shop is not configured to block privacy regulation in online store settings."), function(e) {
                    if ("boolean" != typeof e && "object" != typeof e)
                        throw TypeError("setTrackingConsent must be called with a boolean or object consent value");
                    if ("object" == typeof e) {
                        const n = Object.keys(e);
                        if (0 === n.length)
                            throw TypeError("The submitted consent object is empty.");
                        const t = [F.MARKETING, F.ANALYTICS, F.PREFERENCES, F.SALE_OF_DATA, F.EMAIL, G.ROOT_DOMAIN, G.CHECKOUT_ROOT_DOMAIN, G.STOREFRONT_ROOT_DOMAIN, G.STOREFRONT_ACCESS_TOKEN, G.HEADLESS_STOREFRONT];
                        for (const e of n)
                            if (!t.includes(e))
                                throw TypeError("The submitted consent object should only contain the following keys: ".concat(t.join(", "), ". Extraneous key: ").concat(e, "."))
                    }
                }(e), "function" != typeof n)
                    throw TypeError("setTrackingConsent must be called with a callback function");
                if ("object" == typeof e) {
                    const t = De(e.analytics),
                        o = xe(e.analytics);
                    return (e.storefrontAccessToken ? _e : Ce)(J(J({
                        granular_consent: e
                    }, null !== t && {
                        referrer: t
                    }), null !== o && {
                        landing_page: o
                    }), n)
                }
                {
                    const t = De(e),
                        o = xe(e);
                    return Ce(J(J({
                        consent: e
                    }, null !== t && {
                        referrer: t
                    }), null !== o && {
                        landing_page: o
                    }), n)
                }
            },
            userCanBeTracked: Pe,
            getRegulation: we,
            isRegulationEnforced: Te,
            getShopPrefs: Ae,
            shouldShowGDPRBanner: function() {
                return we() === B.GDPR && Te() && Ee() === M.NO_INTERACTION
            },
            userDataCanBeSold: function() {
                const e = Se(),
                    n = function() {
                        if (ke(U.CCPA))
                            return ne() !== L.DECLINED;
                        return !0
                    }();
                return null !== e && !1 !== n ? e : !!te() || !1 !== Pe() && n
            },
            setCCPAConsent: function(e, n) {
                if ("boolean" != typeof e)
                    throw TypeError("setCCPAConsent must be called with a boolean consent value");
                if ("function" != typeof n)
                    throw TypeError("setCCPAConsent must be called with a callback function");
                return Ce({
                    ccpa_consent: e
                }, n)
            },
            getCCPAConsent: Re,
            GPCSignal: Se,
            shouldShowCCPABanner: function() {
                return we() === B.CCPA && Ae().limit.includes(U.CCPA) && Re() === M.NO_INTERACTION
            },
            haveAnalyticsConsent: function() {
                return de()
            },
            havePreferencesConsent: function() {
                return ue()
            },
            haveMarketingConsent: function() {
                return pe()
            },
            haveSaleOfDataConsent: function() {
                return fe()
            },
            getCCPAConsentValue: ne,
            merchantEnforcingRegulationLimit: ke,
            shouldShowBanner: function() {
                return function() {
                        const e = se();
                        return !!e && "boolean" == typeof e.display_banner && e.display_banner
                    }() && ae(H.ANALYTICS) === L.NO_VALUE && ae(H.MARKETING) === L.NO_VALUE && ae(H.PREFERENCES) === L.NO_VALUE
            },
            saleOfDataRegion: function() {
                return function() {
                    const e = se();
                    return e && e.sale_of_data_region || !1
                }()
            }
        },
        Me = "95ba910bcec4542ef2a0b64cd7ca666c";
    function Le(e, n, t) {
        try {
            var o;
            !function(e) {
                const n = new XMLHttpRequest;
                n.open("POST", "https://notify.bugsnag.com/", !0),
                n.setRequestHeader("Content-Type", "application/json"),
                n.setRequestHeader("Bugsnag-Api-Key", Me),
                n.setRequestHeader("Bugsnag-Payload-Version", "5");
                const t = function(e) {
                    const n = function(e) {
                            return e.stackTrace || e.stack || e.description || e.name
                        }(e.error),
                        [t, o] = (n || "unknown error").split("\n")[0].split(":");
                    return JSON.stringify({
                        payloadVersion: 5,
                        notifier: {
                            name: "ConsentTrackingAPI",
                            version: "latest",
                            url: "-"
                        },
                        events: [{
                            exceptions: [{
                                errorClass: (t || "").trim(),
                                message: (o || "").trim(),
                                stacktrace: [{
                                    file: "consent-tracking-api.js",
                                    lineNumber: "1",
                                    method: n
                                }],
                                type: "browserjs"
                            }],
                            context: e.context || "general",
                            app: {
                                id: "ConsentTrackingAPI",
                                version: "latest"
                            },
                            metaData: {
                                request: {
                                    shopId: e.shopId,
                                    shopUrl: window.location.href
                                },
                                device: {
                                    userAgent: window.navigator.userAgent
                                },
                                "Additional Notes": e.notes
                            },
                            unhandled: !1
                        }]
                    })
                }(e);
                n.send(t)
            }({
                error: e,
                context: n,
                shopId: je() || (null === (o = window.Shopify) || void 0 === o ? void 0 : o.shop),
                notes: t
            })
        } catch (e) {}
    }
    function Be(e) {
        return function() {
            try {
                return e(...arguments)
            } catch (e) {
                throw Le(e), e
            }
        }
    }
    function je() {
        try {
            const e = document.getElementById("shopify-features").textContent;
            return JSON.parse(e).shopId
        } catch (e) {
            return null
        }
    }
    function Ue() {
        return Ne.getTrackingConsent()
    }
    function He(e, n) {
        return "object" == typeof e && e.headlessStorefront && !e.storefrontAccessToken ? function(e, n) {
            function t(e) {
                let n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : L.NO_VALUE;
                return !0 === e ? L.ACCEPTED : !1 === e ? L.DECLINED : n
            }
            const o = {
                    [H.ANALYTICS]: t(e[F.ANALYTICS], L.DECLINED),
                    [H.MARKETING]: t(e[F.MARKETING], L.DECLINED),
                    [H.PREFERENCES]: t(e[F.PREFERENCES], L.DECLINED),
                    [H.SALE_OF_DATA]: t(e[F.SALE_OF_DATA])
                },
                r = {
                    v: N,
                    reg: B.NO_VALUE,
                    lim: [U.GDPR_BLOCK_ALL, U.CCPA],
                    con: {
                        CMP: o
                    }
                },
                a = encodeURIComponent(JSON.stringify(r));
            z(Z, e.rootDomain, 31536e6, a),
            n(null)
        }(e, n) : Ne.setTrackingConsent(e, n)
    }
    function Fe() {
        return Ne.userCanBeTracked()
    }
    function Ge() {
        return Ne.getRegulation()
    }
    function Ke() {
        return Ne.isRegulationEnforced()
    }
    function We() {
        return Ne.getShopPrefs()
    }
    function Ve() {
        return Ne.shouldShowGDPRBanner()
    }
    function qe() {
        return Ne.userDataCanBeSold()
    }
    function ze(e, n) {
        return Ne.setCCPAConsent(e, n)
    }
    function Ye() {
        return Ne.getCCPAConsent()
    }
    function Je() {
        return Ne.shouldShowCCPABanner()
    }
    function Xe() {
        return Ne.haveAnalyticsConsent()
    }
    function Ze() {
        return Ne.havePreferencesConsent()
    }
    function Qe() {
        return Ne.haveMarketingConsent()
    }
    function $e() {
        return Ne.haveSaleOfDataConsent()
    }
    function en() {
        return Ne.shouldShowBanner()
    }
    function nn() {
        return Ne.saleOfDataRegion()
    }
    function tn() {
        return !0
    }
    function on() {
        const e = {},
            n = ee();
        for (const t of Object.keys(n))
            e[re(t)] = oe(n[t]);
        return e
    }
    function rn() {
        Ne.getCCPAConsentValue() != L.DECLINED && !1 === Ne.GPCSignal() && ze(!1, (() => !1));
        return {
            getTrackingConsent: Be(Ue),
            setTrackingConsent: Be(He),
            userCanBeTracked: Be(Fe),
            getRegulation: Be(Ge),
            isRegulationEnforced: Be(Ke),
            getShopPrefs: Be(We),
            shouldShowGDPRBanner: Be(Ve),
            userDataCanBeSold: Be(qe),
            setCCPAConsent: Be(ze),
            getCCPAConsent: Be(Ye),
            shouldShowCCPABanner: Be(Je),
            doesMerchantSupportGranularConsent: Be(tn),
            analyticsProcessingAllowed: Be(Xe),
            preferencesProcessingAllowed: Be(Ze),
            marketingAllowed: Be(Qe),
            firstPartyMarketingAllowed: Be(Qe),
            saleOfDataAllowed: Be($e),
            thirdPartyMarketingAllowed: Be($e),
            currentVisitorConsent: Be(on),
            shouldShowBanner: Be(en),
            saleOfDataRegion: Be(nn),
            unstable: {
                analyticsProcessingAllowed: Xe,
                preferencesProcessingAllowed: Ze,
                marketingAllowed: Qe,
                saleOfDataAllowed: $e,
                currentVisitorConsent: on,
                shouldShowBanner: en,
                saleOfDataRegion: nn
            }
        }
    }
    var an,
        cn,
        sn,
        ln,
        un,
        dn,
        pn;
    !function(e) {
        e.Accepted = "accept",
        e.Declined = "decline",
        e.AcceptedAll = "accept_all",
        e.DeclinedAll = "decline_all",
        e.ManagePreferences = "manage_preferences",
        e.Save = "save",
        e.LeavePreferences = "leave_preferences",
        e.PrivacyPolicyView = "privacy_policy_view"
    }(an || (an = {})),
    function(e) {
        e.StylesContainerId = "shopify-pc__banner__styles",
        e.DialogId = "shopify-pc__banner",
        e.DialogClass = "shopify-pc__banner__dialog",
        e.WrapperClass = "shopify-pc__banner__wrapper",
        e.BodyClass = "shopify-pc__banner__body",
        e.BodyTitleId = "shopify-pc__banner__body-title",
        e.BodyCopyPolicyLinkId = "shopify-pc__banner__body-policy-link",
        e.ButtonsClass = "shopify-pc__banner__btns",
        e.ButtonsGranularClass = "shopify-pc__banner__btns-granular",
        e.ButtonAcceptId = "shopify-pc__banner__btn-accept",
        e.ButtonAcceptClass = "shopify-pc__banner__btn-accept",
        e.ButtonDeclineId = "shopify-pc__banner__btn-decline",
        e.ButtonDeclineClass = "shopify-pc__banner__btn-decline",
        e.ButtonManagePrefsId = "shopify-pc__banner__btn-manage-prefs",
        e.ButtonManagePrefsClass = "shopify-pc__banner__btn-manage-prefs"
    }(cn || (cn = {})),
    function(e) {
        e.StylesContainerId = "shopify-pc__prefs__styles",
        e.OverlayId = "shopify-pc__prefs__overlay",
        e.OverlayClass = "shopify-pc__prefs__overlay",
        e.WrapperId = "shopify-pc__prefs",
        e.WrapperClass = "shopify-pc__prefs",
        e.DialogId = "shopify-pc__prefs__dialog",
        e.DialogClass = "shopify-pc__prefs__dialog",
        e.DialogScrollableClass = "shopify-pc__prefs__scrollable",
        e.HeaderTitleId = "shopify-pc__prefs__header-title",
        e.HeaderActionsClass = "shopify-pc__prefs__header-actions",
        e.HeaderSaveId = "shopify-pc__prefs__header-save",
        e.HeaderAcceptId = "shopify-pc__prefs__header-accept",
        e.HeaderDeclineId = "shopify-pc__prefs__header-decline",
        e.HeaderCloseId = "shopify-pc__prefs__header-close",
        e.HeaderCloseClass = "shopify-pc__prefs__header-close",
        e.IntroClass = "shopify-pc__prefs__intro",
        e.IntroMainClass = "shopify-pc__prefs__intro-main",
        e.IntroExplainWrapperClass = "shopify-pc__prefs__intro-explain",
        e.IntroExplainAcceptClass = "shopify-pc__prefs__intro-explain-accept",
        e.IntroExplainDeclineClass = "shopify-pc__prefs__intro-explain-decline",
        e.OptionWrapperClass = "shopify-pc__prefs__options",
        e.OptionClass = "shopify-pc__prefs__option",
        e.OptionEssentialId = "shopify-pc__prefs__essential",
        e.OptionEssentialInputId = "shopify-pc__prefs__essential-input",
        e.OptionMarketingId = "shopify-pc__prefs__marketing",
        e.OptionMarketingInputId = "shopify-pc__prefs__marketing-input",
        e.OptionAnalyticsId = "shopify-pc__prefs__analytics",
        e.OptionAnalyticsInputId = "shopify-pc__prefs__analytics-input",
        e.OptionPreferencesId = "shopify-pc__prefs__preferences",
        e.OptionPreferencesInputId = "shopify-pc__prefs__preferences-input"
    }(sn || (sn = {})),
    function(e) {
        e.BottomFullWidth = "bottom-full-width",
        e.BottomLeft = "bottom-left",
        e.Center = "center",
        e.BottomRight = "bottom-right",
        e.BottomCenter = "bottom-center"
    }(ln || (ln = {})),
    function(e) {
        e[e.Yes = 1] = "Yes",
        e[e.No = 0] = "No"
    }(un || (un = {})),
    function(e) {
        e.Custom = "custom",
        e.Dark = "dark",
        e.Light = "light"
    }(dn || (dn = {})),
    function(e) {
        e.BottomCenter = "bottom_center",
        e.BottomFullWidth = "bottom_full_width",
        e.BottomLeft = "bottom_left",
        e.BottomRight = "bottom_right",
        e.Center = "center"
    }(pn || (pn = {}));
    var fn,
        hn = function(e) {
            return e ? "auto" : "580px"
        },
        yn = function(e) {
            return e ? "flex-direction: column" : "flex-direction: row;"
        };
    !function(e) {
        e.Black = "#333",
        e.White = "#fff",
        e.Gray = "#ccc",
        e.Green = "#3AA83A",
        e.LightGray = "#F7F8F9",
        e.DarkGray = "#36454F",
        e.VeryDarkGray = "#666",
        e.VeryLightGray = "#e5e5e5"
    }(fn || (fn = {}));
    var mn = function(e) {
            return "\n    border: none;\n    color: ".concat(e.fontColor, ";\n    background: transparent;\n  ")
        },
        gn = function(e) {
            return "\n    border: 1px solid ".concat(e.button.borderColor, ";\n    color: ").concat(e.button.fontColor, ";\n    background: ").concat(e.button.backgroundColor, ";\n  ")
        };
    function vn(e, n, t, o) {
        void 0 === n && (n = "0,0,100,100"),
        void 0 === t && (t = "0,0,0,100"),
        void 0 === o && (o = "0,0,100,100");
        var r = e.split(","),
            a = r[0],
            i = r[1],
            c = r[2],
            s = r[3],
            l = n.split(","),
            u = l[0],
            d = l[1],
            p = l[2],
            f = l[3],
            h = t.split(","),
            y = h[0],
            m = h[1],
            g = h[2],
            v = h[3],
            C = o.split(","),
            b = C[0],
            _ = C[1],
            E = C[2],
            w = C[3],
            A = {
                hue: Number(a),
                saturation: Number(i),
                lightness: Number(c),
                alpha: Number(s)
            },
            D = {
                hue: Number(u),
                saturation: Number(d),
                lightness: Number(p),
                alpha: Number(f)
            },
            x = {
                hue: Number(y),
                saturation: Number(m),
                lightness: Number(g),
                alpha: Number(v)
            },
            I = {
                hue: Number(b),
                saturation: Number(_),
                lightness: Number(E),
                alpha: Number(w)
            },
            O = {
                hue: A.hue,
                saturation: A.saturation,
                lightness: A.lightness,
                alpha: A.alpha - 10
            },
            T = {
                hue: D.hue,
                saturation: D.saturation,
                lightness: D.lightness < 50 ? D.lightness + 14 : D.lightness - 12,
                alpha: D.alpha
            },
            P = {
                hue: 201,
                saturation: D.lightness < 50 ? 60 : 90,
                lightness: D.lightness < 50 ? 60 : 80,
                alpha: D.lightness < 50 ? 80 : 100
            };
        return {
            font: Cn(A),
            fontSubdued: Cn(O),
            buttonFont: Cn(x),
            buttonBackground: Cn(I),
            background: Cn(D),
            divider: Cn(T),
            focused: Cn(P)
        }
    }
    function Cn(e) {
        return "hsl(".concat(e.hue, "deg, ").concat(e.saturation, "%, ").concat(e.lightness, "%, ").concat(e.alpha, "%)")
    }
    function bn(e, n, t, o, r) {
        var a = "0,0,0,100",
            i = "0,0,100,100",
            c = vn("0,0,12,100", "0,0,100,100", "0,0,12,100", "0,0,100,100"),
            s = vn("0,0,100,87", "0,0,12,100", "0,0,100,87", "0,0,12,100"),
            l = vn(null != n ? n : a, null != t ? t : i, null != o ? o : a, null != r ? r : i),
            u = function() {
                switch (e) {
                case dn.Light:
                    return c;
                case dn.Dark:
                    return s;
                case dn.Custom:
                    return l;
                default:
                    return c
                }
            }();
        return {
            backgroundColor: u.background,
            fontColor: u.font,
            fontSubduedColor: u.fontSubdued,
            sectionDivider: u.divider,
            iconColor: u.font,
            focused: u.focused,
            button: {
                borderColor: u.buttonFont,
                backgroundColor: u.buttonBackground,
                fontColor: u.buttonFont
            },
            primaryButton: {
                borderColor: u.buttonBackground,
                backgroundColor: u.buttonFont,
                fontColor: u.buttonBackground
            }
        }
    }
    function _n(e, n) {
        void 0 === n && (n = !1);
        var t = bn(e.theme.theme, e.theme.fontColor, e.theme.backgroundColor, e.theme.buttonFontColor, e.theme.buttonBackgroundColor),
            o = function(e, n) {
                var t = Boolean(e);
                return n ? "display: none;" : t ? "\n      z-index: 2000001;\n      position: fixed;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      background-color: rgba(0, 0, 0, 0.6);\n    " : "display: none;"
            }(un.Yes, n);
        return "\n    .".concat(sn.WrapperClass, " {\n      position: relative;\n    }\n    .").concat(sn.WrapperClass, ':after {\n      content: "";\n      display: block;\n      clear: both;\n    }\n\n    .').concat(sn.DialogClass, " {\n      box-shadow: 0 5px 10px rgb(63 63 68 / 50%);\n      position: ").concat(n ? "static" : "fixed", ";\n      z-index: 2000002;\n      opacity: 1;\n      background-color: ").concat(t.backgroundColor, ";\n      ").concat(n ? "" : "max-height: 80%;", "\n      overflow-y: auto;\n      top: ").concat(n ? "auto" : "50%", ";\n      transform: ").concat(n ? "none" : "translate(0, -50%)", ";\n      min-width: 280px;\n      border-radius: 3px;\n      display: flex;\n      flex-direction: column;\n      left: ").concat(n ? "auto" : "25%", ";\n      width: ").concat(n ? "100%" : "50%", ";\n      text-align: left;\n    }\n    @media only screen and (max-width: 1900px) {\n      .").concat(sn.DialogClass, " {\n        left: ").concat(n ? "auto" : "20%", ";\n        width: ").concat(n ? "auto" : "60%", ";\n      }\n    }\n    @media only screen and (max-width: 1600px) {\n      .").concat(sn.DialogClass, " {\n        left: ").concat(n ? "auto" : "15%", ";\n        width: ").concat(n ? "auto" : "70%", ";\n      }\n    }\n    @media only screen and (max-width: 1350px) {\n      .").concat(sn.DialogClass, " {\n        left: ").concat(n ? "auto" : "5%", ";\n        width: ").concat(n ? "auto" : "90%", ";\n      }\n    }\n\n    .").concat(sn.OverlayClass, " {\n      ").concat(o, "\n    }\n\n    /* Header */\n\n    .").concat(sn.DialogClass, " header {\n      display: flex;\n      flex-direction: ").concat(n ? "column" : "row", ";\n      justify-content: space-between;\n      align-items: center;\n      padding: 32px 32px 20px 32px;\n      border-bottom: 1px solid ").concat(t.sectionDivider, ";\n      position: relative;\n      background: transparent;\n    }\n\n    @media only screen and (max-width: 1200px) {\n      .").concat(sn.DialogClass, " header {\n        flex-direction: column;\n      }\n    }\n    @media only screen and (max-width: 400px) {\n      .").concat(sn.DialogClass, " header {\n        padding: 15px 20px 10px 20px;\n      }\n    }\n    .").concat(sn.DialogClass, " header h2 {\n      color: ").concat(t.fontColor, ";\n      font-family: inherit;\n      margin: ").concat(n ? "0 0 .8em 0" : "0 0 0 0", ";\n      padding: 0 20px 0 0 !important;\n      font-weight: 600;\n      font-size: 130%;\n      line-height: 1.2;\n      width: 100%;\n      text-align: left;\n      word-break: normal;\n    }\n    @media only screen and (max-width: 1200px) {\n      .").concat(sn.DialogClass, " header h2 {\n        margin: 0 0 .8em 0;\n        padding: 0 !important;\n        text-align: ").concat(n ? "left" : "center", ";\n      }\n    }\n    @media only screen and (max-width: 750px) {\n      .").concat(sn.DialogClass, " header h2 {\n        text-align: left;\n        padding: 0 25px 0 0 !important;\n      }\n    }\n\n    .").concat(sn.HeaderCloseClass, " {\n      position: absolute;\n      top: ").concat(n ? "30px" : "40px", ";\n      right: ").concat(n ? "30px" : "35px", ";\n      width: 24px;\n      height: 24px;\n      padding: 0;\n      margin: 0;\n      background: transparent;\n      border: none;\n      outline: none;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      align-content: center;\n      border-radius: 50%;\n      min-width: 24px;\n    }\n\n    .").concat(sn.HeaderCloseClass, " svg {\n      height: 12px;\n      width: 12px;\n    }\n\n    @media only screen and (max-width: 1200px) {\n      .").concat(sn.HeaderCloseClass, " {\n        top: 20px;\n        right: 20px;\n      }\n    }\n    @media only screen and (max-width: 750px) {\n      .").concat(sn.HeaderCloseClass, " {\n        top: 30px;\n        right: 30px;\n      }\n    }\n    @media only screen and (max-width: 400px) {\n      .").concat(sn.HeaderCloseClass, " {\n        top: 15px;\n        right: 15px;\n      }\n    }\n    .").concat(sn.HeaderCloseClass, ":hover {\n      cursor: pointer;\n    }\n    .").concat(sn.HeaderCloseClass, ":focus {\n      outline: none;\n      box-shadow: 0 0 0 3px ").concat(t.focused, ";\n    }\n    .").concat(sn.HeaderCloseClass, " svg path {\n      fill: ").concat(t.fontColor, ";\n    }\n    .").concat(sn.HeaderCloseClass, ":disabled svg path {\n      fill: ").concat(t.sectionDivider, ";\n    }\n\n    .").concat(sn.HeaderActionsClass, " {\n      margin: 0;\n      display: flex;\n      justify-content: space-around;\n      flex-direction: ").concat(n ? "column;" : "row", ";\n      padding: ").concat(n ? "0" : "0 50px 0 0", ";\n      width: ").concat(n ? "100%" : "auto", ";\n    }\n\n    @media only screen and (max-width: 750px) {\n      .").concat(sn.HeaderActionsClass, " {\n        flex-direction: column;\n        width: 100%;\n      }\n    }\n    @media only screen and (max-width: 1200px) {\n      .").concat(sn.HeaderActionsClass, " {\n        padding: 0;\n      }\n    }\n    .").concat(sn.HeaderActionsClass, " button {\n      text-decoration: none;\n      font-family: inherit;\n      padding: 8px 25px 10px 25px;\n      margin: 0 20px 0 0;\n      font-size: 110%;\n      background: ").concat(t.button.backgroundColor, ";\n      color: ").concat(t.button.fontColor, ";\n      border: 1px solid ").concat(t.button.borderColor, ";\n      white-space: nowrap;\n      border-radius: 2px;\n      line-height: 120%;\n      height: unset;\n      ").concat(n ? "width: 100%;" : "", "\n      ").concat(n ? "margin-bottom: 15px;" : "", "\n    }\n    @media only screen and (max-width: 750px) {\n      .").concat(sn.HeaderActionsClass, " button {\n        width: 100%;\n        margin-bottom: 15px;\n      }\n    }\n    .").concat(sn.HeaderActionsClass, " button.primary {\n      background: ").concat(t.primaryButton.backgroundColor, ";\n      color: ").concat(t.primaryButton.fontColor, ";\n      border: 1px solid ").concat(t.primaryButton.borderColor, ";\n    }\n    .").concat(sn.HeaderActionsClass, " button:last-child {\n      margin-right: 0;\n    }\n    .").concat(sn.HeaderActionsClass, " button:hover {\n      cursor: pointer;\n    }\n    .").concat(sn.HeaderActionsClass, " button:focus {\n      outline: none;\n      box-shadow: 0 0 0 4px ").concat(t.focused, ";\n    }\n\n    .").concat(sn.DialogScrollableClass, " {\n      overflow-y: scroll;\n      position: relative;\n    }\n\n    .").concat(sn.DialogScrollableClass, "::-webkit-scrollbar {\n      width: 0px;\n      background: transparent;\n    }\n\n    /* Intro */\n\n    .").concat(sn.IntroClass, " h3 {\n      color: ").concat(t.fontColor, ";\n      font-family: inherit;\n      margin: 0 0 15px 0;\n      padding: 0 !important;\n      font-weight: 600;\n      line-height: 1.2;\n      text-align: left;\n    }\n    .").concat(sn.IntroClass, " p {\n      color: ").concat(t.fontSubduedColor, ";\n      font-family: inherit;\n      margin: 0;\n      padding: 0;\n    }\n    .").concat(sn.IntroClass, " ul {\n      margin: 0;\n      padding: 0;\n    }\n    .").concat(sn.IntroClass, " ul li {\n      margin: 0 0 0.5em 1.7em;\n      padding: 0;\n      line-height: 1.2;\n    }\n    .").concat(sn.IntroMainClass, " {\n      padding: 20px 32px 0 32px;\n      line-height: 1.5;\n    }\n    @media only screen and (max-width: 400px) {\n      .").concat(sn.IntroMainClass, " {\n        padding: 20px 20px 0 20px;\n      }\n    }\n    .").concat(sn.IntroMainClass, " p {\n      padding-bottom: 20px;\n    }\n    .").concat(sn.IntroMainClass, " h3 {\n      font-size: 110%;\n    }\n    .").concat(sn.IntroMainClass, " p {\n      font-size: 105%;\n      margin: 0;\n      padding: 0;\n    }\n    .").concat(sn.IntroExplainWrapperClass, " {\n      display: flex;\n      flex-direction: ").concat(n ? "column" : "row", ";\n      justify-content: center;\n      margin: 0;\n      padding: 20px 32px 0 32px;\n      color: ").concat(t.fontSubduedColor, ";\n    }\n    @media only screen and (max-width: 700px) {\n      .").concat(sn.IntroExplainWrapperClass, " {\n        flex-direction: column;\n        padding-bottom: 0;\n      }\n    }\n    @media only screen and (max-width: 400px) {\n      .").concat(sn.IntroExplainWrapperClass, " {\n        padding: 20px 20px 0 20px;\n      }\n    }\n    .").concat(sn.IntroExplainAcceptClass, " {\n      width: 100%;\n      padding: 0 ").concat(n ? "0" : "40px", " 0 0;\n    }\n    .").concat(sn.IntroExplainAcceptClass, " li {\n      list-style-type: disc;\n    }\n    @media only screen and (max-width: 700px) {\n      .").concat(sn.IntroExplainAcceptClass, " {\n        width: 100%;\n        padding-right: 0;\n      }\n    }\n    .").concat(sn.IntroExplainAcceptClass, " h3 {\n      font-size: 110%;\n    }\n\n    /* Options */\n\n    .").concat(sn.OptionWrapperClass, " {\n      padding: 0 32px 32px 32px;\n      color: ").concat(t.fontColor, ";\n    }\n    @media only screen and (max-width: 400px) {\n      .").concat(sn.OptionWrapperClass, " {\n        padding: 0 20px 15px 20px;\n      }\n    }\n\n    .").concat(sn.OptionClass, " {\n      margin: 0;\n      font-size: 100%;\n      line-height: 1.1;\n      padding: 20px 0 0 0;\n    }\n    .").concat(sn.OptionClass, ":first-child {\n      padding: 25px 0 0 0;\n      margin: 20px 0 0 0;\n      border-top: 1px solid ").concat(t.sectionDivider, ";\n    }\n    .").concat(sn.OptionClass, " label {\n      display: flex;\n      gap: 20px;\n      color: ").concat(t.fontColor, ";\n      cursor: pointer;\n      font-family: inherit;\n      margin: 0 0 5px 0;\n      padding: 0;\n      font-weight: 600;\n      font-size: 110%;\n      line-height: 1.2;\n    }\n    .").concat(sn.OptionClass, " label input {\n      position: absolute;\n      clip: rect(1px, 1px, 1px, 1px);\n      padding: 0;\n      border: 0;\n      height: 1px;\n      width: 1px;\n      overflow: hidden;\n    }\n    .").concat(sn.OptionClass, " label span {\n      order: -1;\n      display: inline-block;\n      background-color: ").concat(t.backgroundColor, ";\n      width: 24px;\n      height: 24px;\n    }\n    .").concat(sn.OptionClass, " label span svg {\n      background-color: ").concat(t.backgroundColor, ";\n      border-radius: 3px;\n    }\n    .").concat(sn.OptionClass, ' label input[aria-readonly="true"] ~ span svg {\n      opacity: 0.2;\n      cursor: not-allowed;\n    }\n    .').concat(sn.OptionClass, " label input:focus ~ span {\n      background-color: ").concat(t.focused, ";\n    }\n    .").concat(sn.OptionClass, " label input:focus ~ span svg {\n      outline: none;\n      border-radius: 5px;\n      box-shadow: 0 0 0 4px ").concat(t.focused, ";\n    }\n    .").concat(sn.OptionClass, " p {\n      line-height: ").concat(n ? "1.4" : "1.3", ";\n      font-size: 100%;\n      color: ").concat(t.fontSubduedColor, ";\n      margin: 0;\n      padding: 0 0 0 45px;\n    }\n    @media only screen and (max-width: 700px) {\n      .").concat(sn.OptionClass, " p {\n        width: 100%;\n        line-height: 1.4;\n      }\n    }\n    ​")
    }
    function En(e, n) {
        void 0 === n && (n = !1);
        var t = bn(e.theme.theme, e.theme.fontColor, e.theme.backgroundColor, e.theme.buttonFontColor, e.theme.buttonBackgroundColor),
            o = function(e, n, t) {
                var o = yn(t),
                    r = hn(t),
                    a = "1280px",
                    i = "\n    .".concat(cn.WrapperClass, " {\n      display: flex;\n      align-items: ").concat(t ? "stretch" : "center", ";\n      justify-content: space-between;\n      flex-direction: column;\n    }\n  "),
                    c = "\n    position: ".concat(t ? "static" : "fixed", ";\n    z-index: 2000000;\n    box-shadow: 0px 4px 10px rgb(63 63 68 / 40%);\n    max-height: 90%;\n    box-sizing: border-box;\n    opacity: 1;\n    padding: 32px;\n    background-color: ").concat(n.backgroundColor, ";\n    overflow: auto;\n    -ms-overflow-style: none;\n    scrollbar-width: none;\n    border: none;\n    text-align: left;\n  "),
                    s = function(e) {
                        var n = ".".concat(cn.ButtonsClass, " {\n      flex-direction: column;\n    }\n    .").concat(cn.ButtonsGranularClass, " :nth-child(1) {\n      order: 3;\n    }\n    .").concat(cn.ButtonsGranularClass, " :nth-child(2) {\n      order: 1;\n    }\n    .").concat(cn.ButtonsGranularClass, " :nth-child(3) {\n      order: 2;\n    }");
                        return e ? n : "\n      @media only screen and (max-width: 480px) {\n        ".concat(n, "\n      }\n    ")
                    },
                    l = "\n    .".concat(cn.DialogClass, " {\n      ").concat(c, "\n      bottom: 0%;\n      width: 100%;\n    }\n    .").concat(cn.DialogClass, " button {\n      margin: ").concat(t ? "15px" : "0", " 10px 0 0;\n    }\n    @media only screen and (max-width: ").concat(a, ") {\n      .").concat(cn.DialogClass, " button {\n        margin: 15px 10px 0 0;\n      }\n    }\n    ").concat(i, "\n    .").concat(cn.WrapperClass, " {\n      flex-direction: ").concat(t ? "column" : "row", ";\n    }\n    @media only screen and (max-width: ").concat(a, ") {\n      .").concat(cn.WrapperClass, " {\n        flex-direction: column;\n      }\n    }\n    .").concat(cn.BodyClass, " {\n      margin-right: 5%;\n      margin-bottom: 0;\n    }\n    @media only screen and (max-width: ").concat(a, ") {\n      .").concat(cn.BodyClass, " {\n        margin-right: 0;\n        margin-bottom: 10px;\n        width: 100%;\n      }\n    }\n    .").concat(cn.ButtonsClass, " {\n      display: flex;\n      min-width: ").concat(r, ";\n      ").concat(o, "\n    }\n    @media only screen and (max-width: ").concat(a, ") {\n      .").concat(cn.ButtonsClass, " {\n        min-width: auto;\n        width: 100%;\n        justify-content: flex-end;\n      }\n    }\n    ").concat(s(t), "\n  "),
                    u = "\n    .".concat(cn.DialogClass, " {\n      ").concat(c, "\n      top: 50%;\n      left: 25%;\n      width: 50%;\n      transform: translate(0, -50%);\n      min-width: 280px;\n      border-radius: 3px;\n    }\n    ").concat(i, "\n    @media only screen and (max-width: 1300px) {\n      .").concat(cn.DialogClass, " {\n        left: 15%;\n        width: 70%;\n      }\n    }\n    @media only screen and (max-width: 900px) {\n      .").concat(cn.DialogClass, " {\n        left: 5%;\n        width: 90%;\n      }\n    }\n    .").concat(cn.BodyClass, " {\n      width: 100%;\n      margin-bottom: 10px;\n    }\n    .").concat(cn.ButtonsClass, " {\n      display: flex;\n      width: 100%;\n      justify-content: flex-end;\n      ").concat(o, "\n    }\n    ").concat(s(t), "\n  "),
                    d = "\n    .".concat(cn.DialogClass, " {\n      ").concat(c, "\n      bottom: 0;\n      left: 0;\n      max-width: 650px;\n      border-top-right-radius: 3px;\n    }\n    ").concat(i, "\n    .").concat(cn.BodyClass, " {\n      width: 100%;\n      margin-bottom: 10px;\n    }\n    .").concat(cn.ButtonsClass, " {\n      display: flex;\n      justify-content: flex-end;\n      width: 100%;\n      ").concat(o, "\n    }\n    ").concat(s(t), "\n  "),
                    p = "\n    .".concat(cn.DialogClass, " {\n      ").concat(c, "\n      bottom: 0;\n      right: 0;\n      max-width: 650px;\n      border-top-left-radius: 3px;\n    }\n    ").concat(i, "\n    .").concat(cn.BodyClass, " {\n      width: 100%;\n      margin-bottom: 10px;\n    }\n    .").concat(cn.ButtonsClass, " {\n      display: flex;\n      justify-content: flex-end;\n      width: 100%;\n      ").concat(o, "\n    }\n    ").concat(s(t), "\n  "),
                    f = "\n    .".concat(cn.DialogClass, " {\n      ").concat(c, "\n      bottom: 0;\n      left: 25%;\n      width: 50%;\n      min-width: 280px;\n      border-top-right-radius: 3px;\n      border-top-left-radius: 3px;\n    }\n    ").concat(i, "\n    @media only screen and (max-width: 1300px) {\n      .").concat(cn.DialogClass, " {\n        left: 15%;\n        width: 70%;\n      }\n    }\n    @media only screen and (max-width: 900px) {\n      .").concat(cn.DialogClass, " {\n        left: 5%;\n        width: 90%;\n      }\n    }\n    .").concat(cn.BodyClass, " {\n      width: 100%;\n      margin-bottom: 10px;\n    }\n    .").concat(cn.ButtonsClass, " {\n      display: flex;\n      width: 100%;\n      justify-content: flex-end;\n      ").concat(o, "\n    }\n    ").concat(s(t), "\n  ");
                if (t)
                    return l;
                switch (e) {
                case pn.BottomFullWidth:
                    return l;
                case pn.Center:
                    return u;
                case pn.BottomLeft:
                    return d;
                case pn.BottomRight:
                    return p;
                case pn.BottomCenter:
                    return f;
                default:
                    return l
                }
            }(e.position, t, n),
            r = function(e, n) {
                if (e === dn.Custom)
                    return {
                        accept: gn(n),
                        decline: gn(n),
                        manage: mn(n)
                    };
                var t = e === dn.Dark,
                    o = "\n    background: ".concat(t ? fn.Black : fn.White, ";\n    color: ").concat(t ? fn.White : fn.Black, ";\n  ");
                return {
                    accept: o,
                    decline: o,
                    manage: "\n    background: transparent;\n    border: none;\n    color: ".concat(t ? fn.White : fn.Black, ";\n  ")
                }
            }(e.theme.theme, t);
        return "\n    .".concat(cn.DialogClass, " h2 {\n      color: ").concat(t.fontColor, ";\n      font-family: inherit;\n      font-size: 120%;\n      margin: 0 0 .5em 0;\n      padding: 0;\n      font-weight: bold;\n    }\n    .").concat(cn.DialogClass, " p {\n      color: ").concat(t.fontColor, ";\n      font-family: inherit;\n      line-height: 1.3;\n      margin: 0;\n      padding: 0;\n    }\n    .").concat(cn.DialogClass, " a {\n      color: ").concat(t.fontColor, ";\n      text-decoration: underline;\n    }\n    .").concat(cn.DialogClass, " button {\n      border: none;\n      text-decoration: none;\n      font-family: inherit;\n      padding: 8px 25px;\n      margin: 15px 20px 0 0;\n      font-size: 100%;\n      flex-basis: 50%;\n      border-radius: 2px;\n      line-height: 120%;\n      height: unset;\n      text-align: center;\n    }\n    .").concat(cn.DialogClass, " button:focus {\n      outline: none;\n      box-shadow: 0 0 0 4px ").concat(t.focused, ";\n    }\n    .").concat(cn.DialogClass, " button:hover {\n      cursor: pointer;\n    }\n    .").concat(cn.DialogClass, " button.").concat(cn.ButtonAcceptClass, " {\n      border: 1px solid ").concat(t.button.borderColor, ";\n      ").concat(r.accept, "\n    }\n    .").concat(cn.DialogClass, " button.").concat(cn.ButtonManagePrefsClass, " {\n      text-decoration: underline;\n      ").concat(r.manage, "\n    }\n    .").concat(cn.DialogClass, " button.").concat(cn.ButtonManagePrefsClass, ":focus {\n      box-shadow: none;\n    }\n    .").concat(cn.DialogClass, " button.").concat(cn.ButtonManagePrefsClass, ":focus span {\n      outline: 2px solid ").concat(t.focused, ";\n    }\n    .").concat(cn.DialogClass, " button.").concat(cn.ButtonDeclineClass, " {\n      border: 1px solid ").concat(t.button.borderColor, ";\n      ").concat(r.decline, "\n    }\n\n    .").concat(cn.BodyClass, " p a:focus {\n      outline: 2px solid ").concat(t.focused, ";\n      box-shadow: none;\n    }\n\n    ").concat(o, "\n  ​")
    }
    function wn(e) {
        var n = window.location.search.substring(1);
        if (0 === n.length)
            return null;
        var t = n.split("&").map((function(e) {
                return e.split("=")
            })),
            o = t.filter((function(n) {
                return n[0] === e
            }))[0];
        return (o ? o[1] : null) || null
    }
    function An(e) {
        var n = window.Shopify.customerPrivacy,
            t = {
                marketing: e.marketing,
                analytics: e.analytics,
                preferences: e.preferences,
                sale_of_data: e.sale_of_data
            };
        e.storefrontAccessToken && (t.headlessStorefront = !0, t.checkoutRootDomain = e.checkoutRootDomain, t.storefrontRootDomain = e.storefrontRootDomain, t.storefrontAccessToken = e.storefrontAccessToken),
        n.setTrackingConsent(t, e.callback)
    }
    var Dn = function() {
            function e() {}
            return e.getServerData = function(e, n) {
                var t;
                return s(this, void 0, void 0, (function() {
                    return l(this, (function(o) {
                        return this.domain = e || (null === (t = window.Shopify) || void 0 === t ? void 0 : t.shop), this.appUrl = "https://privacy-banner.shopifyapps.com", this.accessToken = n, "native" === wn("preview_privacy_banner") ? [2, this.getDataFromStorefrontApi()] : [2, this.getServerDataWithBackoff()]
                    }))
                }))
            }, e.getDataFromStorefrontApi = function() {
                return s(this, void 0, void 0, (function() {
                    var e,
                        n,
                        t,
                        r;
                    return l(this, (function(a) {
                        switch (a.label) {
                        case 0:
                            if (!this.domain || !this.accessToken)
                                throw new Error("Missing domain or access token");
                            return e = {
                                headers: {
                                    "content-type": "application/json",
                                    "x-shopify-storefront-access-token": this.accessToken
                                },
                                body: JSON.stringify({
                                    query: "\n        query bannerQuery {\n          consentManagement {\n            banner {\n              enabled\n              position\n              policyLinkText\n              policyLinkUrl\n              title\n              text\n              buttonPrefsOpenText\n              buttonAcceptText\n              buttonDeclineText\n              theme {\n                theme\n                fontColor\n                backgroundColor\n                buttonFontColor\n                buttonBackgroundColor\n              }\n              preferences {\n                title\n                introTitle\n                introText\n                buttonAcceptText\n                buttonDeclineText\n                buttonSaveText\n                bulletPoints {\n                  enabled\n                  title\n                  firstText\n                  secondText\n                  thirdText\n                }\n                purposes {\n                  essentialName\n                  essentialDesc\n                  performanceName\n                  performanceDesc\n                  preferencesName\n                  preferencesDesc\n                  marketingName\n                  marketingDesc\n                }\n              }\n            }\n          }\n        }"
                                }),
                                method: "POST"
                            }, n = "https://".concat(this.domain, "/api/unstable/graphql.json?fast_storefront_renderer=1").concat(wn("preview_privacy_banners") ? "&cache=walrus-no-cache-deep" : ""), [4, fetch(n, e)];
                        case 1:
                            return 200 !== (t = a.sent()).status ? [3, 3] : [4, t.json()];
                        case 2:
                            if ((r = a.sent()).errors)
                                throw new Error(r.errors[0].message);
                            return [2, o({}, r.data.consentManagement.banner)];
                        case 3:
                            throw new Error("Could not reach the server")
                        }
                    }))
                }))
            }, e.getServerDataWithBackoff = function(e) {
                return void 0 === e && (e = 1), s(this, void 0, void 0, (function() {
                    var n,
                        t,
                        o,
                        r;
                    return l(this, (function(a) {
                        switch (a.label) {
                        case 0:
                            return n = "".concat(this.appUrl, "/customization?shopify_domain=").concat(this.domain), t = "".concat(n, "&request_attempt=").concat(e), [4, fetch(t)];
                        case 1:
                            return [4, (o = a.sent()).json()];
                        case 2:
                            return r = a.sent(), 200 === o.status ? void 0 === r.visible ? [2] : [2, this.convertToBannerData(r)] : e < this.MAX_RETRIES ? [4, this.wait()] : [3, 4];
                        case 3:
                            return a.sent(), [2, this.getServerDataWithBackoff(e + 1)];
                        case 4:
                            throw new Error("Could not reach the server")
                        }
                    }))
                }))
            }, e.convertToBannerData = function(e) {
                return {
                    enabled: e.visible,
                    position: e.bannerPosition,
                    policyLinkText: e.policyTitle,
                    policyLinkUrl: e.policyLink,
                    title: e.title,
                    text: e.bannerCopy,
                    buttonPrefsOpenText: e.managePrefsButtonCopy,
                    buttonAcceptText: e.acceptButtonCopy,
                    buttonDeclineText: e.declineButtonCopy,
                    theme: {
                        theme: e.theme,
                        fontColor: e.themeColorHslFont,
                        backgroundColor: e.themeColorHslBackground,
                        buttonFontColor: e.themeColorHslButtonFont,
                        buttonBackgroundColor: e.themeColorHslButtonBackground
                    },
                    preferences: {
                        title: e.granularConsentTitle,
                        introTitle: e.granularConsentCopyTitle,
                        introText: e.granularConsentCopy,
                        buttonAcceptText: e.granularConsentAcceptAllCopy,
                        buttonDeclineText: e.granularConsentDeclineAllCopy,
                        buttonSaveText: e.granularConsentSubmitCopy,
                        bulletPoints: {
                            enabled: e.granularConsentBulletPointsEnabled,
                            title: e.granularConsentIfAccept,
                            firstText: e.granularConsentBulletPointPerformance,
                            secondText: e.granularConsentBulletPointPreferences,
                            thirdText: e.granularConsentBulletPointMarketing
                        },
                        purposes: {
                            essentialName: e.essentialPurposeShortDescription,
                            essentialDesc: e.essentialPurposeLongDescription,
                            performanceName: e.performancePurposeShortDescription,
                            performanceDesc: e.performancePurposeLongDescription,
                            preferencesName: e.preferencesPurposeShortDescription,
                            preferencesDesc: e.preferencesPurposeLongDescription,
                            marketingName: e.marketingPurposeShortDescription,
                            marketingDesc: e.marketingPurposeLongDescription
                        }
                    }
                }
            }, e.wait = function() {
                var e = this;
                return new Promise((function(n) {
                    return setTimeout(n, e.TIME_BETWEEN_REQUESTS)
                }))
            }, e.MAX_RETRIES = 6, e.TIME_BETWEEN_REQUESTS = 5e3, e
        }(),
        xn = function() {
            return !window.location.pathname.match(/^(\/[a-zA-Z]{2}(-[a-zA-Z]{2})?)?\/(cart|policies\/privacy-policy|password)$/)
        },
        In = function() {
            var e = wn("preview_privacy_banners");
          let banner = getCookieDnt("banner")
          console.log("banner", banner)
          if (!banner || banner == "") {
            return true
          } else {
            return false
          }
            
        };
    function On(e) {
        if (e.__esModule)
            return e;
        var n = e.default;
        if ("function" == typeof n) {
            var t = function e() {
                return this instanceof e ? Reflect.construct(n, arguments, this.constructor) : n.apply(this, arguments)
            };
            t.prototype = n.prototype
        } else
            t = {};
        return Object.defineProperty(t, "__esModule", {
            value: !0
        }), Object.keys(e).forEach((function(n) {
            var o = Object.getOwnPropertyDescriptor(e, n);
            Object.defineProperty(t, n, o.get ? o : {
                enumerable: !0,
                get: function() {
                    return e[n]
                }
            })
        })), t
    }
    var Tn = {},
        Pn = {},
        kn = On(S),
        Sn = {};
    Object.defineProperty(Sn, "__esModule", {
        value: !0
    }),
    Sn.extractDomain = Sn.PRODUCTION_CANADA_ENDPOINT = Sn.PRODUCE_ENDPOINT = Sn.PRODUCE_BATCH_ENDPOINT = Sn.PRODUCTION_DOMAIN = Sn.DEVELOPMENT_DOMAIN = void 0,
    Sn.DEVELOPMENT_DOMAIN = "http://localhost:8082",
    Sn.PRODUCTION_DOMAIN = "https://monorail-edge.shopifysvc.com",
    Sn.PRODUCE_BATCH_ENDPOINT = "/unstable/produce_batch",
    Sn.PRODUCE_ENDPOINT = "/v1/produce",
    Sn.PRODUCTION_CANADA_ENDPOINT = "https://monorail-edge-ca.shopifycloud.com/v1/produce",
    Sn.extractDomain = function(e) {
        return "https://".concat(new URL(e).hostname)
    };
    var Rn = {},
        Nn = {};
    Object.defineProperty(Nn, "__esModule", {
        value: !0
    }),
    Nn.isCompositeMonorailEvent = void 0,
    Nn.isCompositeMonorailEvent = function(e) {
        return void 0 !== e.schemaId
    },
    Object.defineProperty(Rn, "__esModule", {
        value: !0
    }),
    Rn.ProducerMiddleware = void 0;
    var Mn = Nn,
        Ln = function() {
            function e(e) {
                this.producer = e
            }
            return e.prototype.do = function(e, n) {
                return (0, Mn.isCompositeMonorailEvent)(e) ? this.producer.produce(e) : this.producer.produceBatch(e)
            }, e
        }();
    Rn.ProducerMiddleware = Ln;
    var Bn,
        jn = {},
        Un = {},
        Hn = {},
        Fn = {};
    function Gn() {
        if (Bn)
            return Fn;
        let e;
        Bn = 1,
        Object.defineProperty(Fn, "__esModule", {
            value: !0
        }),
        Fn.default = function() {
            if (!e && (e = "undefined" != typeof crypto && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !e))
                throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
            return e(n)
        };
        const n = new Uint8Array(16);
        return Fn
    }
    var Kn,
        Wn,
        Vn,
        qn,
        zn = {},
        Yn = {},
        Jn = {};
    function Xn() {
        if (Wn)
            return Yn;
        Wn = 1,
        Object.defineProperty(Yn, "__esModule", {
            value: !0
        }),
        Yn.default = void 0;
        var e,
            n = (Kn || (Kn = 1, Object.defineProperty(Jn, "__esModule", {
                value: !0
            }), Jn.default = void 0, Jn.default = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i), (e = Jn) && e.__esModule ? e : {
                default: e
            });
        var t = function(e) {
            return "string" == typeof e && n.default.test(e)
        };
        return Yn.default = t, Yn
    }
    function Zn() {
        if (Vn)
            return zn;
        Vn = 1,
        Object.defineProperty(zn, "__esModule", {
            value: !0
        }),
        zn.default = void 0,
        zn.unsafeStringify = o;
        var e,
            n = (e = Xn()) && e.__esModule ? e : {
                default: e
            };
        const t = [];
        for (let e = 0; e < 256; ++e)
            t.push((e + 256).toString(16).slice(1));
        function o(e, n=0) {
            return (t[e[n + 0]] + t[e[n + 1]] + t[e[n + 2]] + t[e[n + 3]] + "-" + t[e[n + 4]] + t[e[n + 5]] + "-" + t[e[n + 6]] + t[e[n + 7]] + "-" + t[e[n + 8]] + t[e[n + 9]] + "-" + t[e[n + 10]] + t[e[n + 11]] + t[e[n + 12]] + t[e[n + 13]] + t[e[n + 14]] + t[e[n + 15]]).toLowerCase()
        }
        var r = function(e, t=0) {
            const r = o(e, t);
            if (!(0, n.default)(r))
                throw TypeError("Stringified UUID is invalid");
            return r
        };
        return zn.default = r, zn
    }
    var Qn,
        $n,
        et = {},
        nt = {},
        tt = {};
    function ot() {
        if (Qn)
            return tt;
        Qn = 1,
        Object.defineProperty(tt, "__esModule", {
            value: !0
        }),
        tt.default = void 0;
        var e,
            n = (e = Xn()) && e.__esModule ? e : {
                default: e
            };
        var t = function(e) {
            if (!(0, n.default)(e))
                throw TypeError("Invalid UUID");
            let t;
            const o = new Uint8Array(16);
            return o[0] = (t = parseInt(e.slice(0, 8), 16)) >>> 24, o[1] = t >>> 16 & 255, o[2] = t >>> 8 & 255, o[3] = 255 & t, o[4] = (t = parseInt(e.slice(9, 13), 16)) >>> 8, o[5] = 255 & t, o[6] = (t = parseInt(e.slice(14, 18), 16)) >>> 8, o[7] = 255 & t, o[8] = (t = parseInt(e.slice(19, 23), 16)) >>> 8, o[9] = 255 & t, o[10] = (t = parseInt(e.slice(24, 36), 16)) / 1099511627776 & 255, o[11] = t / 4294967296 & 255, o[12] = t >>> 24 & 255, o[13] = t >>> 16 & 255, o[14] = t >>> 8 & 255, o[15] = 255 & t, o
        };
        return tt.default = t, tt
    }
    function rt() {
        if ($n)
            return nt;
        $n = 1,
        Object.defineProperty(nt, "__esModule", {
            value: !0
        }),
        nt.URL = nt.DNS = void 0,
        nt.default = function(e, a, i) {
            function c(e, o, r, c) {
                var s;
                if ("string" == typeof e && (e = function(e) {
                    e = unescape(encodeURIComponent(e));
                    const n = [];
                    for (let t = 0; t < e.length; ++t)
                        n.push(e.charCodeAt(t));
                    return n
                }(e)), "string" == typeof o && (o = (0, t.default)(o)), 16 !== (null === (s = o) || void 0 === s ? void 0 : s.length))
                    throw TypeError("Namespace must be array-like (16 iterable integer values, 0-255)");
                let l = new Uint8Array(16 + e.length);
                if (l.set(o), l.set(e, o.length), l = i(l), l[6] = 15 & l[6] | a, l[8] = 63 & l[8] | 128, r) {
                    c = c || 0;
                    for (let e = 0; e < 16; ++e)
                        r[c + e] = l[e];
                    return r
                }
                return (0, n.unsafeStringify)(l)
            }
            try {
                c.name = e
            } catch (e) {}
            return c.DNS = o, c.URL = r, c
        };
        var e,
            n = Zn(),
            t = (e = ot()) && e.__esModule ? e : {
                default: e
            };
        const o = "6ba7b810-9dad-11d1-80b4-00c04fd430c8";
        nt.DNS = o;
        const r = "6ba7b811-9dad-11d1-80b4-00c04fd430c8";
        return nt.URL = r, nt
    }
    var at,
        it,
        ct = {};
    function st() {
        if (at)
            return ct;
        function e(e) {
            return 14 + (e + 64 >>> 9 << 4) + 1
        }
        function n(e, n) {
            const t = (65535 & e) + (65535 & n);
            return (e >> 16) + (n >> 16) + (t >> 16) << 16 | 65535 & t
        }
        function t(e, t, o, r, a, i) {
            return n((c = n(n(t, e), n(r, i))) << (s = a) | c >>> 32 - s, o);
            var c,
                s
        }
        function o(e, n, o, r, a, i, c) {
            return t(n & o | ~n & r, e, n, a, i, c)
        }
        function r(e, n, o, r, a, i, c) {
            return t(n & r | o & ~r, e, n, a, i, c)
        }
        function a(e, n, o, r, a, i, c) {
            return t(n ^ o ^ r, e, n, a, i, c)
        }
        function i(e, n, o, r, a, i, c) {
            return t(o ^ (n | ~r), e, n, a, i, c)
        }
        at = 1,
        Object.defineProperty(ct, "__esModule", {
            value: !0
        }),
        ct.default = void 0;
        var c = function(t) {
            if ("string" == typeof t) {
                const e = unescape(encodeURIComponent(t));
                t = new Uint8Array(e.length);
                for (let n = 0; n < e.length; ++n)
                    t[n] = e.charCodeAt(n)
            }
            return function(e) {
                const n = [],
                    t = 32 * e.length,
                    o = "0123456789abcdef";
                for (let r = 0; r < t; r += 8) {
                    const t = e[r >> 5] >>> r % 32 & 255,
                        a = parseInt(o.charAt(t >>> 4 & 15) + o.charAt(15 & t), 16);
                    n.push(a)
                }
                return n
            }(function(t, c) {
                t[c >> 5] |= 128 << c % 32,
                t[e(c) - 1] = c;
                let s = 1732584193,
                    l = -271733879,
                    u = -1732584194,
                    d = 271733878;
                for (let e = 0; e < t.length; e += 16) {
                    const c = s,
                        p = l,
                        f = u,
                        h = d;
                    s = o(s, l, u, d, t[e], 7, -680876936),
                    d = o(d, s, l, u, t[e + 1], 12, -389564586),
                    u = o(u, d, s, l, t[e + 2], 17, 606105819),
                    l = o(l, u, d, s, t[e + 3], 22, -1044525330),
                    s = o(s, l, u, d, t[e + 4], 7, -176418897),
                    d = o(d, s, l, u, t[e + 5], 12, 1200080426),
                    u = o(u, d, s, l, t[e + 6], 17, -1473231341),
                    l = o(l, u, d, s, t[e + 7], 22, -45705983),
                    s = o(s, l, u, d, t[e + 8], 7, 1770035416),
                    d = o(d, s, l, u, t[e + 9], 12, -1958414417),
                    u = o(u, d, s, l, t[e + 10], 17, -42063),
                    l = o(l, u, d, s, t[e + 11], 22, -1990404162),
                    s = o(s, l, u, d, t[e + 12], 7, 1804603682),
                    d = o(d, s, l, u, t[e + 13], 12, -40341101),
                    u = o(u, d, s, l, t[e + 14], 17, -1502002290),
                    l = o(l, u, d, s, t[e + 15], 22, 1236535329),
                    s = r(s, l, u, d, t[e + 1], 5, -165796510),
                    d = r(d, s, l, u, t[e + 6], 9, -1069501632),
                    u = r(u, d, s, l, t[e + 11], 14, 643717713),
                    l = r(l, u, d, s, t[e], 20, -373897302),
                    s = r(s, l, u, d, t[e + 5], 5, -701558691),
                    d = r(d, s, l, u, t[e + 10], 9, 38016083),
                    u = r(u, d, s, l, t[e + 15], 14, -660478335),
                    l = r(l, u, d, s, t[e + 4], 20, -405537848),
                    s = r(s, l, u, d, t[e + 9], 5, 568446438),
                    d = r(d, s, l, u, t[e + 14], 9, -1019803690),
                    u = r(u, d, s, l, t[e + 3], 14, -187363961),
                    l = r(l, u, d, s, t[e + 8], 20, 1163531501),
                    s = r(s, l, u, d, t[e + 13], 5, -1444681467),
                    d = r(d, s, l, u, t[e + 2], 9, -51403784),
                    u = r(u, d, s, l, t[e + 7], 14, 1735328473),
                    l = r(l, u, d, s, t[e + 12], 20, -1926607734),
                    s = a(s, l, u, d, t[e + 5], 4, -378558),
                    d = a(d, s, l, u, t[e + 8], 11, -2022574463),
                    u = a(u, d, s, l, t[e + 11], 16, 1839030562),
                    l = a(l, u, d, s, t[e + 14], 23, -35309556),
                    s = a(s, l, u, d, t[e + 1], 4, -1530992060),
                    d = a(d, s, l, u, t[e + 4], 11, 1272893353),
                    u = a(u, d, s, l, t[e + 7], 16, -155497632),
                    l = a(l, u, d, s, t[e + 10], 23, -1094730640),
                    s = a(s, l, u, d, t[e + 13], 4, 681279174),
                    d = a(d, s, l, u, t[e], 11, -358537222),
                    u = a(u, d, s, l, t[e + 3], 16, -722521979),
                    l = a(l, u, d, s, t[e + 6], 23, 76029189),
                    s = a(s, l, u, d, t[e + 9], 4, -640364487),
                    d = a(d, s, l, u, t[e + 12], 11, -421815835),
                    u = a(u, d, s, l, t[e + 15], 16, 530742520),
                    l = a(l, u, d, s, t[e + 2], 23, -995338651),
                    s = i(s, l, u, d, t[e], 6, -198630844),
                    d = i(d, s, l, u, t[e + 7], 10, 1126891415),
                    u = i(u, d, s, l, t[e + 14], 15, -1416354905),
                    l = i(l, u, d, s, t[e + 5], 21, -57434055),
                    s = i(s, l, u, d, t[e + 12], 6, 1700485571),
                    d = i(d, s, l, u, t[e + 3], 10, -1894986606),
                    u = i(u, d, s, l, t[e + 10], 15, -1051523),
                    l = i(l, u, d, s, t[e + 1], 21, -2054922799),
                    s = i(s, l, u, d, t[e + 8], 6, 1873313359),
                    d = i(d, s, l, u, t[e + 15], 10, -30611744),
                    u = i(u, d, s, l, t[e + 6], 15, -1560198380),
                    l = i(l, u, d, s, t[e + 13], 21, 1309151649),
                    s = i(s, l, u, d, t[e + 4], 6, -145523070),
                    d = i(d, s, l, u, t[e + 11], 10, -1120210379),
                    u = i(u, d, s, l, t[e + 2], 15, 718787259),
                    l = i(l, u, d, s, t[e + 9], 21, -343485551),
                    s = n(s, c),
                    l = n(l, p),
                    u = n(u, f),
                    d = n(d, h)
                }
                return [s, l, u, d]
            }(function(n) {
                if (0 === n.length)
                    return [];
                const t = 8 * n.length,
                    o = new Uint32Array(e(t));
                for (let e = 0; e < t; e += 8)
                    o[e >> 5] |= (255 & n[e / 8]) << e % 32;
                return o
            }(t), 8 * t.length))
        };
        return ct.default = c, ct
    }
    var lt,
        ut,
        dt = {},
        pt = {};
    function ft() {
        if (ut)
            return dt;
        ut = 1,
        Object.defineProperty(dt, "__esModule", {
            value: !0
        }),
        dt.default = void 0;
        var e = o(function() {
                if (lt)
                    return pt;
                lt = 1,
                Object.defineProperty(pt, "__esModule", {
                    value: !0
                }),
                pt.default = void 0;
                var e = {
                    randomUUID: "undefined" != typeof crypto && crypto.randomUUID && crypto.randomUUID.bind(crypto)
                };
                return pt.default = e, pt
            }()),
            n = o(Gn()),
            t = Zn();
        function o(e) {
            return e && e.__esModule ? e : {
                default: e
            }
        }
        var r = function(o, r, a) {
            if (e.default.randomUUID && !r && !o)
                return e.default.randomUUID();
            const i = (o = o || {}).random || (o.rng || n.default)();
            if (i[6] = 15 & i[6] | 64, i[8] = 63 & i[8] | 128, r) {
                a = a || 0;
                for (let e = 0; e < 16; ++e)
                    r[a + e] = i[e];
                return r
            }
            return (0, t.unsafeStringify)(i)
        };
        return dt.default = r, dt
    }
    var ht,
        yt,
        mt = {},
        gt = {};
    function vt() {
        if (yt)
            return mt;
        yt = 1,
        Object.defineProperty(mt, "__esModule", {
            value: !0
        }),
        mt.default = void 0;
        var e = t(rt()),
            n = t(function() {
                if (ht)
                    return gt;
                function e(e, n, t, o) {
                    switch (e) {
                    case 0:
                        return n & t ^ ~n & o;
                    case 1:
                    case 3:
                        return n ^ t ^ o;
                    case 2:
                        return n & t ^ n & o ^ t & o
                    }
                }
                function n(e, n) {
                    return e << n | e >>> 32 - n
                }
                ht = 1,
                Object.defineProperty(gt, "__esModule", {
                    value: !0
                }),
                gt.default = void 0;
                var t = function(t) {
                    const o = [1518500249, 1859775393, 2400959708, 3395469782],
                        r = [1732584193, 4023233417, 2562383102, 271733878, 3285377520];
                    if ("string" == typeof t) {
                        const e = unescape(encodeURIComponent(t));
                        t = [];
                        for (let n = 0; n < e.length; ++n)
                            t.push(e.charCodeAt(n))
                    } else
                        Array.isArray(t) || (t = Array.prototype.slice.call(t));
                    t.push(128);
                    const a = t.length / 4 + 2,
                        i = Math.ceil(a / 16),
                        c = new Array(i);
                    for (let e = 0; e < i; ++e) {
                        const n = new Uint32Array(16);
                        for (let o = 0; o < 16; ++o)
                            n[o] = t[64 * e + 4 * o] << 24 | t[64 * e + 4 * o + 1] << 16 | t[64 * e + 4 * o + 2] << 8 | t[64 * e + 4 * o + 3];
                        c[e] = n
                    }
                    c[i - 1][14] = 8 * (t.length - 1) / Math.pow(2, 32),
                    c[i - 1][14] = Math.floor(c[i - 1][14]),
                    c[i - 1][15] = 8 * (t.length - 1) & 4294967295;
                    for (let t = 0; t < i; ++t) {
                        const a = new Uint32Array(80);
                        for (let e = 0; e < 16; ++e)
                            a[e] = c[t][e];
                        for (let e = 16; e < 80; ++e)
                            a[e] = n(a[e - 3] ^ a[e - 8] ^ a[e - 14] ^ a[e - 16], 1);
                        let i = r[0],
                            s = r[1],
                            l = r[2],
                            u = r[3],
                            d = r[4];
                        for (let t = 0; t < 80; ++t) {
                            const r = Math.floor(t / 20),
                                c = n(i, 5) + e(r, s, l, u) + d + o[r] + a[t] >>> 0;
                            d = u,
                            u = l,
                            l = n(s, 30) >>> 0,
                            s = i,
                            i = c
                        }
                        r[0] = r[0] + i >>> 0,
                        r[1] = r[1] + s >>> 0,
                        r[2] = r[2] + l >>> 0,
                        r[3] = r[3] + u >>> 0,
                        r[4] = r[4] + d >>> 0
                    }
                    return [r[0] >> 24 & 255, r[0] >> 16 & 255, r[0] >> 8 & 255, 255 & r[0], r[1] >> 24 & 255, r[1] >> 16 & 255, r[1] >> 8 & 255, 255 & r[1], r[2] >> 24 & 255, r[2] >> 16 & 255, r[2] >> 8 & 255, 255 & r[2], r[3] >> 24 & 255, r[3] >> 16 & 255, r[3] >> 8 & 255, 255 & r[3], r[4] >> 24 & 255, r[4] >> 16 & 255, r[4] >> 8 & 255, 255 & r[4]]
                };
                return gt.default = t, gt
            }());
        function t(e) {
            return e && e.__esModule ? e : {
                default: e
            }
        }
        var o = (0, e.default)("v5", 80, n.default);
        return mt.default = o, mt
    }
    var Ct,
        bt = {};
    var _t,
        Et,
        wt = {};
    function At() {
        return Et || (Et = 1, function(e) {
            Object.defineProperty(e, "__esModule", {
                value: !0
            }),
            Object.defineProperty(e, "NIL", {
                enumerable: !0,
                get: function() {
                    return a.default
                }
            }),
            Object.defineProperty(e, "parse", {
                enumerable: !0,
                get: function() {
                    return l.default
                }
            }),
            Object.defineProperty(e, "stringify", {
                enumerable: !0,
                get: function() {
                    return s.default
                }
            }),
            Object.defineProperty(e, "v1", {
                enumerable: !0,
                get: function() {
                    return n.default
                }
            }),
            Object.defineProperty(e, "v3", {
                enumerable: !0,
                get: function() {
                    return t.default
                }
            }),
            Object.defineProperty(e, "v4", {
                enumerable: !0,
                get: function() {
                    return o.default
                }
            }),
            Object.defineProperty(e, "v5", {
                enumerable: !0,
                get: function() {
                    return r.default
                }
            }),
            Object.defineProperty(e, "validate", {
                enumerable: !0,
                get: function() {
                    return c.default
                }
            }),
            Object.defineProperty(e, "version", {
                enumerable: !0,
                get: function() {
                    return i.default
                }
            });
            var n = u(function() {
                    if (qn)
                        return Hn;
                    qn = 1,
                    Object.defineProperty(Hn, "__esModule", {
                        value: !0
                    }),
                    Hn.default = void 0;
                    var e,
                        n = (e = Gn()) && e.__esModule ? e : {
                            default: e
                        },
                        t = Zn();
                    let o,
                        r,
                        a = 0,
                        i = 0;
                    var c = function(e, c, s) {
                        let l = c && s || 0;
                        const u = c || new Array(16);
                        let d = (e = e || {}).node || o,
                            p = void 0 !== e.clockseq ? e.clockseq : r;
                        if (null == d || null == p) {
                            const t = e.random || (e.rng || n.default)();
                            null == d && (d = o = [1 | t[0], t[1], t[2], t[3], t[4], t[5]]),
                            null == p && (p = r = 16383 & (t[6] << 8 | t[7]))
                        }
                        let f = void 0 !== e.msecs ? e.msecs : Date.now(),
                            h = void 0 !== e.nsecs ? e.nsecs : i + 1;
                        const y = f - a + (h - i) / 1e4;
                        if (y < 0 && void 0 === e.clockseq && (p = p + 1 & 16383), (y < 0 || f > a) && void 0 === e.nsecs && (h = 0), h >= 1e4)
                            throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
                        a = f,
                        i = h,
                        r = p,
                        f += 122192928e5;
                        const m = (1e4 * (268435455 & f) + h) % 4294967296;
                        u[l++] = m >>> 24 & 255,
                        u[l++] = m >>> 16 & 255,
                        u[l++] = m >>> 8 & 255,
                        u[l++] = 255 & m;
                        const g = f / 4294967296 * 1e4 & 268435455;
                        u[l++] = g >>> 8 & 255,
                        u[l++] = 255 & g,
                        u[l++] = g >>> 24 & 15 | 16,
                        u[l++] = g >>> 16 & 255,
                        u[l++] = p >>> 8 | 128,
                        u[l++] = 255 & p;
                        for (let e = 0; e < 6; ++e)
                            u[l + e] = d[e];
                        return c || (0, t.unsafeStringify)(u)
                    };
                    return Hn.default = c, Hn
                }()),
                t = u(function() {
                    if (it)
                        return et;
                    it = 1,
                    Object.defineProperty(et, "__esModule", {
                        value: !0
                    }),
                    et.default = void 0;
                    var e = t(rt()),
                        n = t(st());
                    function t(e) {
                        return e && e.__esModule ? e : {
                            default: e
                        }
                    }
                    var o = (0, e.default)("v3", 48, n.default);
                    return et.default = o, et
                }()),
                o = u(ft()),
                r = u(vt()),
                a = u((Ct || (Ct = 1, Object.defineProperty(bt, "__esModule", {
                    value: !0
                }), bt.default = void 0, bt.default = "00000000-0000-0000-0000-000000000000"), bt)),
                i = u(function() {
                    if (_t)
                        return wt;
                    _t = 1,
                    Object.defineProperty(wt, "__esModule", {
                        value: !0
                    }),
                    wt.default = void 0;
                    var e,
                        n = (e = Xn()) && e.__esModule ? e : {
                            default: e
                        },
                        t = function(e) {
                            if (!(0, n.default)(e))
                                throw TypeError("Invalid UUID");
                            return parseInt(e.slice(14, 15), 16)
                        };
                    return wt.default = t, wt
                }()),
                c = u(Xn()),
                s = u(Zn()),
                l = u(ot());
            function u(e) {
                return e && e.__esModule ? e : {
                    default: e
                }
            }
        }(Un)), Un
    }
    Object.defineProperty(jn, "__esModule", {
        value: !0
    }),
    jn.v4 = void 0,
    jn.v4 = function() {
        return "object" == typeof crypto && "function" == typeof crypto.randomUUID ? crypto.randomUUID() : At().v4()
    };
    var Dt = {},
        xt = {};
    Object.defineProperty(xt, "__esModule", {
        value: !0
    }),
    xt.toUnderscoreCase = xt.convertAllEventsToUnderscoreCase = xt.convertStringToUnderscoreCase = void 0;
    var It = kn;
    function Ot(e, n) {
        return void 0 === n && (n = !0), e && Object.keys(e).length && n ? Object.keys(e).map((function(n) {
            var t;
            return (t = {})[Tt(n)] = e[n], t
        })).reduce((function(e, n) {
            return It.__assign(It.__assign({}, e), n)
        })) : e
    }
    function Tt(e) {
        return e.split(/(?=[A-Z])/).join("_").toLowerCase()
    }
    xt.toUnderscoreCase = Ot,
    xt.convertStringToUnderscoreCase = Tt,
    xt.convertAllEventsToUnderscoreCase = function(e) {
        return e.events.map((function(e) {
            var n = !0,
                t = !0;
            return e && e.options && Object.prototype.hasOwnProperty.call(e.options, "convertEventCase") && (n = Boolean(e.options.convertEventCase)), e && e.options && Object.prototype.hasOwnProperty.call(e.options, "convertMetaDataCase") && (t = Boolean(e.options.convertMetaDataCase)), {
                schema_id: e.schemaId,
                payload: Ot(e.payload, n),
                metadata: Ot(e.metadata, t)
            }
        }))
    };
    var Pt = {};
    Object.defineProperty(Pt, "__esModule", {
        value: !0
    }),
    Pt.MonorailRetriesExceededError = Pt.MonorailRequestError = Pt.MonorailBatchProduceError = Pt.MonorailUnableToProduceError = void 0;
    var kt = kn,
        St = function(e) {
            function n(t) {
                var o = e.call(this, "Error producing to the Monorail Edge. Response received: ".concat(JSON.stringify(t))) || this;
                return o.response = t, Object.setPrototypeOf(o, n.prototype), o
            }
            return kt.__extends(n, e), n
        }(Error);
    Pt.MonorailUnableToProduceError = St;
    var Rt = function(e) {
        function n(t) {
            var o = e.call(this, "Error producing to the Monorail Edge. Response received: ".concat(JSON.stringify(t))) || this;
            return Object.setPrototypeOf(o, n.prototype), o.response = t, o
        }
        return kt.__extends(n, e), n
    }(Error);
    Pt.MonorailBatchProduceError = Rt;
    var Nt = function(e) {
        function n(t) {
            var o = e.call(this, "Error completing request. A network failure may have prevented the request from completing. Error: ".concat(t)) || this;
            return Object.setPrototypeOf(o, n.prototype), o
        }
        return kt.__extends(n, e), n
    }(Error);
    Pt.MonorailRequestError = Nt;
    var Mt = function(e) {
        function n(t) {
            var o = e.call(this, "".concat(t)) || this;
            return Object.setPrototypeOf(o, n.prototype), o
        }
        return kt.__extends(n, e), n
    }(Error);
    Pt.MonorailRetriesExceededError = Mt,
    Object.defineProperty(Dt, "__esModule", {
        value: !0
    }),
    Dt.HttpProducer = void 0;
    var Lt = kn,
        Bt = Sn,
        jt = xt,
        Ut = jn,
        Ht = Pt,
        Ft = function() {
            function e(e, n) {
                void 0 === e && (e = Bt.DEVELOPMENT_DOMAIN),
                void 0 === n && (n = !1),
                this.edgeDomain = e,
                this.keepalive = n
            }
            return e.withEndpoint = function(n) {
                return new e(Bt.extractDomain(n))
            }, e.getHeadersFromMetadata = function(e) {
                var n = {
                    "Content-Type": "application/json; charset=utf-8",
                    "X-Monorail-Edge-Event-Created-At-Ms": (e && e.eventCreatedAtMs || Date.now()).toString(),
                    "X-Monorail-Edge-Event-Sent-At-Ms": Date.now().toString(),
                    "X-Monorail-Edge-Client-Message-Id": (e && e.clientMessageId || (0, Ut.v4)()).toString()
                };
                return e && e.userAgent && (n["User-Agent"] = e.userAgent), e && e.remoteIp && (n["X-Forwarded-For"] = e.remoteIp), n
            }, e.prototype.produceBatch = function(n) {
                return Lt.__awaiter(this, void 0, void 0, (function() {
                    var t,
                        o,
                        r,
                        a,
                        i,
                        c;
                    return Lt.__generator(this, (function(s) {
                        switch (s.label) {
                        case 0:
                            t = {
                                events: (0, jt.convertAllEventsToUnderscoreCase)(n),
                                metadata: (0, jt.toUnderscoreCase)(n.metadata)
                            },
                            s.label = 1;
                        case 1:
                            return s.trys.push([1, 3, , 4]), [4, fetch(this.produceBatchEndpoint(), {
                                method: "post",
                                headers: e.getHeadersFromMetadata(n.metadata),
                                body: JSON.stringify(t),
                                keepalive: this.keepalive
                            })];
                        case 2:
                            return o = s.sent(), [3, 4];
                        case 3:
                            throw r = s.sent(), new Ht.MonorailRequestError(r);
                        case 4:
                            return 207 !== o.status ? [3, 6] : [4, o.json()];
                        case 5:
                            throw a = s.sent(), new Ht.MonorailBatchProduceError(a);
                        case 6:
                            return o.ok ? [3, 8] : (i = Ht.MonorailUnableToProduceError.bind, c = {
                                status: o.status
                            }, [4, o.text()]);
                        case 7:
                            throw new (i.apply(Ht.MonorailUnableToProduceError, [void 0, (c.message = s.sent(), c)]));
                        case 8:
                            return [2, {
                                status: o.status
                            }]
                        }
                    }))
                }))
            }, e.prototype.produce = function(n) {
                return Lt.__awaiter(this, void 0, void 0, (function() {
                    var t,
                        o,
                        r,
                        a,
                        i,
                        c;
                    return Lt.__generator(this, (function(s) {
                        switch (s.label) {
                        case 0:
                            t = !0,
                            n && n.options && Object.prototype.hasOwnProperty.call(n.options, "convertEventCase") && (t = Boolean(n.options.convertEventCase)),
                            o = {
                                schema_id: n.schemaId,
                                payload: (0, jt.toUnderscoreCase)(n.payload, t)
                            },
                            s.label = 1;
                        case 1:
                            return s.trys.push([1, 3, , 4]), [4, fetch(this.produceEndpoint(), {
                                method: "post",
                                headers: e.getHeadersFromMetadata(n.metadata),
                                body: JSON.stringify(o),
                                keepalive: this.keepalive
                            })];
                        case 2:
                            return r = s.sent(), [3, 4];
                        case 3:
                            throw a = s.sent(), new Ht.MonorailRequestError(a);
                        case 4:
                            if (!r)
                                throw new Ht.MonorailUnableToProduceError({
                                    message: "No response from edge"
                                });
                            return r.ok ? [3, 6] : (i = Ht.MonorailUnableToProduceError.bind, c = {
                                status: r.status
                            }, [4, r.text()]);
                        case 5:
                            throw new (i.apply(Ht.MonorailUnableToProduceError, [void 0, (c.message = s.sent(), c)]));
                        case 6:
                            return [2, {
                                status: r.status
                            }]
                        }
                    }))
                }))
            }, e.prototype.produceBatchEndpoint = function() {
                return this.edgeDomain + Bt.PRODUCE_BATCH_ENDPOINT
            }, e.prototype.produceEndpoint = function() {
                return this.edgeDomain + Bt.PRODUCE_ENDPOINT
            }, e
        }();
    Dt.HttpProducer = Ft;
    var Gt = {};
    Object.defineProperty(Gt, "__esModule", {
        value: !0
    }),
    Gt.LogProducer = void 0;
    var Kt = function() {
        function e(n) {
            this.sendToConsole = n,
            n && e.printWelcomeMessage(n)
        }
        return e.printWelcomeMessage = function(e) {
            console.log("%c👋 from Monorail%c\n\n" + "We've noticed that you're".concat(e ? "" : " not", " ") + "running in debug mode. " + "As such, we will ".concat(e ? "produce" : "not produce", " ") + "Monorail events to the console. " + "\n\nIf you want Monorail events to ".concat(e ? "stop" : "start", " ") + "appearing here, %cset debugMode=".concat((!e).toString(), "%c, ") + "for the Monorail Log Producer in your code.", "font-size: large;", "font-size: normal;", "font-weight: bold;", "font-weight: normal;")
        }, e.prototype.produce = function(e) {
            return this.sendToConsole && console.log("Monorail event produced", e), new Promise((function(n) {
                n(e)
            }))
        }, e.prototype.produceBatch = function(e) {
            return this.sendToConsole && console.log("Monorail Batch event produced", e), new Promise((function(n) {
                n(e)
            }))
        }, e
    }();
    Gt.LogProducer = Kt,
    Object.defineProperty(Pn, "__esModule", {
        value: !0
    }),
    Pn.Monorail = void 0;
    var Wt = kn,
        Vt = Sn,
        qt = Rn,
        zt = jn,
        Yt = Dt,
        Jt = Gt,
        Xt = function() {
            function e(n, t) {
                this.producer = n,
                this.middleware = t,
                this.executeChain = e.buildMiddlewareChain(this.middleware.concat(new qt.ProducerMiddleware(n)))
            }
            return e.createLogProducer = function(n) {
                return new e(new Jt.LogProducer(n.debugMode), n.middleware || [])
            }, e.createHttpProducerWithEndpoint = function(n, t) {
                return void 0 === t && (t = []), new e(Yt.HttpProducer.withEndpoint(n), t)
            }, e.createHttpProducer = function(n) {
                var t = n.options && n.options.keepalive;
                return new e(n.production ? new Yt.HttpProducer(Vt.PRODUCTION_DOMAIN, t) : new Yt.HttpProducer(Vt.DEVELOPMENT_DOMAIN, t), n.middleware || [])
            }, e.buildMiddlewareChain = function(e, n) {
                var t = this;
                return void 0 === n && (n = 0), n === e.length ? this.identityFn : function(o) {
                    return e[n].do(o, t.buildMiddlewareChain(e, n + 1))
                }
            }, e.prototype.produce = function(e) {
                return e.metadata = Wt.__assign({
                    eventCreatedAtMs: Date.now(),
                    clientMessageId: (0, zt.v4)()
                }, e.metadata), this.executeChain(e)
            }, e.prototype.produceBatch = function(e) {
                return this.executeChain(e)
            }, e
        }();
    Pn.Monorail = Xt;
    var Zt = {};
    Object.defineProperty(Zt, "__esModule", {
        value: !0
    }),
    Zt.RetryMiddleware = void 0;
    var Qt = kn,
        $t = Pt,
        eo = function() {
            function e(e, n) {
                void 0 === e && (e = 3),
                void 0 === n && (n = 150),
                this.maxRetries = e,
                this.delayMs = n
            }
            return e.prototype.do = function(e, n) {
                return Qt.__awaiter(this, void 0, void 0, (function() {
                    var t,
                        o,
                        r,
                        a,
                        i;
                    return Qt.__generator(this, (function(c) {
                        switch (c.label) {
                        case 0:
                            t = 0,
                            c.label = 1;
                        case 1:
                            if (!(t < this.maxRetries))
                                return [3, 7];
                            r = void 0,
                            c.label = 2;
                        case 2:
                            return c.trys.push([2, 4, , 6]), [4, n(e)];
                        case 3:
                            return r = c.sent(), [3, 6];
                        case 4:
                            if (a = c.sent(), o = o || new Error, o = new Error("".concat(o.message, " Retry count:").concat(t + 1, " Error msg:").concat(a.message, "\n")), a instanceof $t.MonorailUnableToProduceError && (i = a.response.status) && i >= 400 && i < 500)
                                throw a;
                            return [4, this.delay(this.delayMs * Math.pow(2, t))];
                        case 5:
                            return c.sent(), t++, [3, 1];
                        case 6:
                            return [2, r];
                        case 7:
                            throw o ? o.message = "Retry count of ".concat(this.maxRetries, " exceeded. Failed with error: \n").concat(o.message, " Aborting request for ").concat(JSON.stringify(e)) : o = new Error, new $t.MonorailRetriesExceededError(o)
                        }
                    }))
                }))
            }, e.prototype.delay = function(e) {
                return new Promise((function(n) {
                    return setTimeout(n, e)
                }))
            }, e
        }();
    Zt.RetryMiddleware = eo,
    function(e) {
        Object.defineProperty(e, "__esModule", {
            value: !0
        }),
        e.RetryMiddleware = e.MonorailRetriesExceededError = e.MonorailUnableToProduceError = e.MonorailRequestError = e.Monorail = void 0;
        var n = Pn;
        Object.defineProperty(e, "Monorail", {
            enumerable: !0,
            get: function() {
                return n.Monorail
            }
        });
        var t = Pt;
        Object.defineProperty(e, "MonorailRequestError", {
            enumerable: !0,
            get: function() {
                return t.MonorailRequestError
            }
        }),
        Object.defineProperty(e, "MonorailUnableToProduceError", {
            enumerable: !0,
            get: function() {
                return t.MonorailUnableToProduceError
            }
        }),
        Object.defineProperty(e, "MonorailRetriesExceededError", {
            enumerable: !0,
            get: function() {
                return t.MonorailRetriesExceededError
            }
        });
        var o = Zt;
        Object.defineProperty(e, "RetryMiddleware", {
            enumerable: !0,
            get: function() {
                return o.RetryMiddleware
            }
        })
    }(Tn);
    var no,
        to = function() {
            function e(e) {
                var n = void 0 === e ? {} : e,
                    t = n.shopDomain,
                    o = n.isHeadless;
                this.VISIT_TOKEN = "_shopify_s",
                this.shopDomain = t,
                this.isHeadless = o,
                this.monorail = Tn.Monorail.createHttpProducer({
                    production: !0
                })
            }
            return e.prototype.shouldEmit = function() {
                return !(this.isHeadless && !0)
            }, e.prototype.emitInteraction = function(e, n) {
                if (void 0 === n && (n = ""), this.shouldEmit()) {
                    var t = this.getCommonPayload();
                    this.monorail.produce({
                        schemaId: "privacy_banner_interact/1.1",
                        payload: o(o(o({}, t), n && {
                            interactionMetadata: n
                        }), {
                            interactionType: e
                        })
                    })
                }
            }, e.prototype.emitRender = function() {
                if (this.shouldEmit()) {
                    var e = this.getCommonPayload();
                    this.monorail.produce({
                        schemaId: "privacy_banner_render/1.0",
                        payload: o({}, e)
                    })
                }
            }, e.prototype.visitorRegion = function() {
                var e = document.cookie.split(";").find((function(e) {
                    return e.includes("_tracking_consent=")
                }));
                if (!e)
                    return null;
                var n = {};
                try {
                    n = JSON.parse(unescape(e.split("=")[1]))
                } catch (e) {
                    return null
                }
                return n.region || null
            }, e.prototype.getCommonPayload = function() {
                var e,
                    n = this.shopDomain || (null === (e = window.Shopify) || void 0 === e ? void 0 : e.shop),
                    t = function(e) {
                        for (var n = 0, t = decodeURIComponent(document.cookie).split(";"); n < t.length; n++) {
                            var o = t[n].split("="),
                                r = o[0],
                                a = o[1];
                            if (r.trim() === e)
                                return a
                        }
                        return ""
                    }(this.VISIT_TOKEN) || "0",
                    r = window.Shopify.customerPrivacy.getRegulation(),
                    a = window.location.pathname,
                    i = this.visitorRegion();
                return o({
                    shopPermanentDomain: n,
                    sessionToken: t,
                    regulation: r,
                    path: a
                }, i && {
                    region: i
                })
            }, e
        }();
    function oo(e, n) {
        return (null == n ? void 0 : n.id) && e.setAttribute("id", n.id), (null == n ? void 0 : n.class) && e.setAttribute("class", n.class), (null == n ? void 0 : n.onClick) && e.addEventListener("click", n.onClick), (null == n ? void 0 : n.appendTo) && n.appendTo.appendChild(e), (null == n ? void 0 : n.role) && e.setAttribute("role", n.role), (null == n ? void 0 : n.autofocus) && e.setAttribute("autofocus", ""), (null == n ? void 0 : n.ariaHidden) && e.setAttribute("aria-hidden", "".concat(null == n ? void 0 : n.ariaHidden)), e
    }
    function ro(e) {
        var n = oo(document.createElement("div"), e);
        return (null == e ? void 0 : e.text) && (n.textContent = e.text), (null == e ? void 0 : e.ariaModal) && n.setAttribute("aria-modal", e.ariaModal), (null == e ? void 0 : e.ariaLabelledby) && n.setAttribute("aria-labelledby", e.ariaLabelledby), n
    }
    function ao(e) {
        var n = oo(document.createElement("span"), e);
        return (null == e ? void 0 : e.text) && (n.textContent = e.text), n
    }
    function io(e) {
        var n,
            t = oo(document.createElement("button"), e);
        return t.textContent = null !== (n = null == e ? void 0 : e.text) && void 0 !== n ? n : null, e.disabled && t.setAttribute("disabled", ""), e.ariaHaspopup && t.setAttribute("aria-haspopup", e.ariaHaspopup), e.type && t.setAttribute("type", e.type), e.ariaLabel && t.setAttribute("aria-label", e.ariaLabel), t
    }
    function co(e) {
        var n = oo(document.createElement("p"), e);
        return n.textContent = e.text, n
    }
    function so(e, n) {
        var t = oo(document.createElement(e), n);
        return t.textContent = n.text, t
    }
    function lo(e) {
        return so(no.H2, e)
    }
    function uo(e) {
        return so(no.H3, e)
    }
    function po(e) {
        var n = oo(document.createElement("style"), e);
        return n.textContent = e.content, n
    }
    function fo(e) {
        var n = document.createElementNS("http://www.w3.org/2000/svg", "svg");
        n.setAttributeNS(null, "width", e.width),
        n.setAttributeNS(null, "height", e.height),
        n.setAttributeNS(null, "viewBox", "0 0 ".concat(e.width, " ").concat(e.height)),
        (null == e ? void 0 : e.fillRule) && n.setAttributeNS(null, "fill-rule", e.fillRule),
        (null == e ? void 0 : e.clipRule) && n.setAttributeNS(null, "clip-rule", e.clipRule);
        var t = document.createElementNS("http://www.w3.org/2000/svg", "path");
        return t.setAttributeNS(null, "fill", (null == e ? void 0 : e.colour) || "#000"), t.setAttributeNS(null, "d", e.path), n.appendChild(t), (null == e ? void 0 : e.id) && n.setAttribute("id", e.id), (null == e ? void 0 : e.class) && n.setAttribute("class", e.class), (null == e ? void 0 : e.dataIconType) && n.setAttribute("data-icon-type", e.dataIconType), (null == e ? void 0 : e.ariaHidden) && n.setAttribute("aria-hidden", "".concat(null == e ? void 0 : e.ariaHidden)), (null == e ? void 0 : e.focusable) && n.setAttribute("focusable", "".concat(null == e ? void 0 : e.focusable)), (null == e ? void 0 : e.appendTo) && e.appendTo.appendChild(n), n
    }
    function ho(e) {
        var n = oo(document.createElement("section"), e);
        return (null == e ? void 0 : e.text) && (n.textContent = e.text), (null == e ? void 0 : e.ariaModal) && n.setAttribute("aria-modal", e.ariaModal), (null == e ? void 0 : e.ariaLabelledby) && n.setAttribute("aria-labelledby", e.ariaLabelledby), n
    }
    function yo(e, n) {
        void 0 === n && (n = !1);
        var t = ho({
                id: cn.DialogId,
                class: cn.DialogClass,
                role: "alertdialog",
                ariaModal: "false",
                ariaLabelledby: cn.BodyTitleId
            }),
            o = ro({
                class: cn.WrapperClass
            });
        t.appendChild(o);
        var r = ro({
            class: cn.BodyClass
        });
        o.appendChild(r);
        var a = ro({
            class: cn.ButtonsClass
        });
        return o.appendChild(a), function(e, n) {
            if (e.title) {
                var t = lo({
                    id: cn.BodyTitleId,
                    text: e.title
                });
                n.appendChild(t)
            }
        }(e, r), function(e, n) {
            var t = co({
                    text: "".concat(e.text, " ")
                }),
                o = function(e) {
                    var n = oo(document.createElement("a"), e);
                    return n.setAttribute("href", e.href), n.textContent = e.text, n.setAttribute("target", void 0 === e.target ? "_blank" : e.target), e.target && "_blank" !== e.target || n.setAttribute("rel", "noopener noreferrer"), n
                }({
                    id: cn.BodyCopyPolicyLinkId,
                    href: e.policyLinkUrl,
                    target: "_blank",
                    text: e.policyLinkText ? e.policyLinkText : "Privacy Policy"
                });
            t.appendChild(o),
            n.appendChild(t)
        }(e, r), function(e, n) {
            var t = ao({
                    text: e.buttonPrefsOpenText
                }),
                o = io({
                    id: cn.ButtonManagePrefsId,
                    class: cn.ButtonManagePrefsClass,
                    ariaHaspopup: "dialog",
                    type: "button"
                });
            o.appendChild(t),
            n.appendChild(o)
        }(e, a), a.classList.add(cn.ButtonsGranularClass), function(e, n, t) {
            n.appendChild(io({
                disabled: t,
                id: cn.ButtonAcceptId,
                class: cn.ButtonAcceptClass,
                type: "button",
                text: e.buttonAcceptText
            }))
        }(e, a, n), function(e, n, t) {
            n.appendChild(io({
                disabled: t,
                id: cn.ButtonDeclineId,
                class: cn.ButtonDeclineClass,
                type: "button",
                text: e.buttonDeclineText
            }))
        }(e, a, n), t
    }
    function mo(e, n, t) {
        void 0 === t && (t = !1);
        var o,
            r,
            a,
            i,
            c = (o = {
                appendTo: e
            }, oo(document.createElement("header"), o));
        r = c,
        a = "Close dialog",
        fo({
            appendTo: i = io({
                id: sn.HeaderCloseId,
                class: sn.HeaderCloseClass,
                ariaLabel: a,
                type: "button",
                text: ""
            }),
            ariaHidden: !0,
            width: "12",
            height: "12",
            path: "M7.41401 6.00012L11.707 1.70721C12.098 1.31622 12.098 0.684236 11.707 0.293244C11.316 -0.097748 10.684 -0.097748 10.293 0.293244L6.00001 4.58615L1.70701 0.293244C1.31601 -0.097748 0.684006 -0.097748 0.293006 0.293244C-0.0979941 0.684236 -0.0979941 1.31622 0.293006 1.70721L4.58601 6.00012L0.293006 10.293C-0.0979941 10.684 -0.0979941 11.316 0.293006 11.707C0.488006 11.902 0.744006 12 1.00001 12C1.25601 12 1.51201 11.902 1.70701 11.707L6.00001 7.4141L10.293 11.707C10.488 11.902 10.744 12 11 12C11.256 12 11.512 11.902 11.707 11.707C12.098 11.316 12.098 10.684 11.707 10.293L7.41401 6.00012Z"
        }),
        r.appendChild(i),
        lo({
            id: sn.HeaderTitleId,
            text: n.preferences.title,
            appendTo: c
        });
        var s = ro({
            class: sn.HeaderActionsClass,
            appendTo: c
        });
        return function(e, n, t) {
            e.appendChild(io({
                disabled: t,
                id: sn.HeaderAcceptId,
                type: "button",
                text: n
            }))
        }(s, n.preferences.buttonAcceptText, t), function(e, n, t) {
            e.appendChild(io({
                disabled: t,
                id: sn.HeaderDeclineId,
                type: "button",
                text: n
            }))
        }(s, n.preferences.buttonDeclineText, t), function(e, n, t) {
            var o = io({
                disabled: t,
                id: sn.HeaderSaveId,
                type: "button",
                text: n
            });
            t && (o.style.display = "block");
            e.appendChild(o)
        }(s, n.preferences.buttonSaveText, t), c
    }
    function go(e, n) {
        var t = ro({
            class: sn.IntroClass,
            appendTo: e
        });
        return function(e, n) {
            var t = ro({
                class: sn.IntroMainClass,
                appendTo: e
            });
            uo({
                text: n.preferences.introTitle,
                appendTo: t
            }),
            co({
                text: n.preferences.introText,
                appendTo: t
            })
        }(t, n), n.preferences.bulletPoints.enabled && function(e, n) {
            var t = ro({
                    class: sn.IntroExplainWrapperClass,
                    appendTo: e
                }),
                o = ro({
                    class: sn.IntroExplainAcceptClass,
                    appendTo: t
                });
            uo({
                text: n.preferences.bulletPoints.title || "",
                appendTo: o
            });
            var r = [];
            n.preferences.bulletPoints.firstText && r.push(n.preferences.bulletPoints.firstText);
            n.preferences.bulletPoints.secondText && r.push(n.preferences.bulletPoints.secondText);
            n.preferences.bulletPoints.thirdText && r.push(n.preferences.bulletPoints.thirdText);
            (function(e) {
                var n = oo(document.createElement("ul"), e);
                e.lis && e.lis.forEach((function(e) {
                    var t = document.createElement("li");
                    t.textContent = e,
                    n.appendChild(t)
                }))
            })({
                lis: r,
                appendTo: o
            })
        }(t, n), t
    }
    function vo(e) {
        var n = e.themeColours,
            t = e.purpose,
            o = e.ids,
            r = e.parent,
            a = o.input === sn.OptionEssentialInputId,
            i = fo({
                dataIconType: "unchecked",
                width: "24",
                height: "24",
                path: "M5 2c-1.654 0-3 1.346-3 3v14c0 1.654 1.346 3 3 3h14c1.654 0 3-1.346 3-3v-14c0-1.654-1.346-3-3-3h-14zm19 3v14c0 2.761-2.238 5-5 5h-14c-2.762 0-5-2.239-5-5v-14c0-2.761 2.238-5 5-5h14c2.762 0 5 2.239 5 5z",
                colour: n.iconColor,
                focusable: !0
            }),
            c = function(e) {
                return fo({
                    dataIconType: "checked",
                    width: "24",
                    height: "24",
                    path: "M19 0h-14c-2.762 0-5 2.239-5 5v14c0 2.761 2.238 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-8.959 17l-4.5-4.319 1.395-1.435 3.08 2.937 7.021-7.183 1.422 1.409-8.418 8.591z",
                    colour: e,
                    focusable: !0
                })
            }(n.iconColor),
            s = ro({
                class: sn.OptionClass,
                id: o.section
            }),
            l = function(e) {
                var n = oo(document.createElement("label"), e);
                return n.setAttribute("for", e.for), (null == e ? void 0 : e.text) && (n.textContent = e.text), n
            }({
                appendTo: s,
                for: o.input,
                text: t.description
            });
        !function(e) {
            var n = oo(document.createElement("input"), e);
            n.setAttribute("type", e.type),
            e.checked && n.setAttribute("checked", "true"),
            e.disabled && n.setAttribute("disabled", "".concat(e.disabled)),
            (null == e ? void 0 : e.onChange) && n.addEventListener("change", e.onChange),
            e.tabindex && n.setAttribute("tabindex", "".concat(e.tabindex)),
            !0 === e.ariaReadonly && n.setAttribute("aria-readonly", "".concat(e.ariaReadonly))
        }({
            appendTo: l,
            id: o.input,
            type: "checkbox",
            checked: a,
            ariaReadonly: a,
            tabindex: "0"
        });
        var u = ao({
            appendTo: l,
            ariaHidden: !0
        });
        u.appendChild(c),
        u.appendChild(i),
        co({
            appendTo: s,
            text: t.longDescription
        }),
        a ? (c.style.display = "block", i.style.display = "none") : (c.style.display = "none", i.style.display = "block"),
        r.appendChild(s)
    }
    function Co(e, n) {
        void 0 === n && (n = !1);
        var t = ro({
                id: sn.WrapperId,
                class: sn.WrapperClass
            }),
            o = ro({
                id: sn.OverlayId,
                class: sn.OverlayClass,
                text: " "
            });
        t.appendChild(o);
        var r = ho({
            id: sn.DialogId,
            class: sn.DialogClass,
            role: "dialog",
            ariaModal: "true",
            ariaLabelledby: sn.HeaderTitleId
        });
        t.appendChild(r),
        mo(r, e, n);
        var a = ro({
            class: sn.DialogScrollableClass
        });
        return r.appendChild(a), go(a, e), function(e, n, t) {
            var o = bn(n.theme.theme, n.theme.fontColor, n.theme.backgroundColor, n.theme.buttonFontColor, n.theme.buttonBackgroundColor),
                r = ro({
                    class: sn.OptionWrapperClass
                });
            e.appendChild(r),
            vo({
                themeColours: o,
                ids: {
                    section: sn.OptionEssentialId,
                    input: sn.OptionEssentialInputId
                },
                purpose: {
                    description: n.preferences.purposes.essentialName,
                    longDescription: n.preferences.purposes.essentialDesc
                },
                parent: r,
                adminPreview: t
            }),
            vo({
                themeColours: o,
                ids: {
                    section: sn.OptionAnalyticsId,
                    input: sn.OptionAnalyticsInputId
                },
                purpose: {
                    description: n.preferences.purposes.performanceName,
                    longDescription: n.preferences.purposes.performanceDesc
                },
                parent: r,
                adminPreview: t
            }),
            vo({
                themeColours: o,
                ids: {
                    section: sn.OptionPreferencesId,
                    input: sn.OptionPreferencesInputId
                },
                purpose: {
                    description: n.preferences.purposes.preferencesName,
                    longDescription: n.preferences.purposes.preferencesDesc
                },
                parent: r,
                adminPreview: t
            }),
            vo({
                themeColours: o,
                ids: {
                    section: sn.OptionMarketingId,
                    input: sn.OptionMarketingInputId
                },
                purpose: {
                    description: n.preferences.purposes.marketingName,
                    longDescription: n.preferences.purposes.marketingDesc
                },
                parent: r,
                adminPreview: t
            })
        }(a, e, n), t
    }
    !function(e) {
        e.H1 = "h1",
        e.H2 = "h2",
        e.H3 = "h3"
    }(no || (no = {}));
    var bo = function() {
            function e(e) {
                var n = e.bannerData,
                    t = e.shopDomain,
                    o = e.storefrontAccessToken,
                    r = e.checkoutRootDomain,
                    a = e.storefrontRootDomain;
                this.bannerData = n,
                t && o ? (this.storefrontAccessToken = o, this.checkoutRootDomain = r, this.storefrontRootDomain = a, this.logger = new to({
                    shopDomain: t,
                    isHeadless: !0
                })) : this.logger = new to
            }
            return e.show = function() {
                var e = document.getElementById(sn.WrapperId);
                null !== e && (e.style.display = "block", document.body.style.setProperty("overflow", "hidden"))
            }, e.hide = function() {
                var e = document.getElementById(sn.WrapperId);
                null !== e && (e.style.display = "none", document.body.style.removeProperty("overflow"))
            }, e.hideModalAndBanner = function() {
                var e = document.getElementById(sn.WrapperId);
                null !== e && (e.style.display = "none", document.body.style.removeProperty("overflow"));
                var n = document.getElementById(cn.DialogId);
                null !== n && (n.style.display = "none")
            }, e.selectedConsent = function() {
                var e = document.getElementById(sn.OptionMarketingInputId),
                    n = document.getElementById(sn.OptionAnalyticsInputId),
                    t = document.getElementById(sn.OptionPreferencesInputId),
                    o = e.checked ? "1" : "0",
                    r = n.checked ? "1" : "0",
                    a = t.checked ? "1" : "0";
                return "".concat(o).concat(r).concat(a)
            }, e.prototype.init = function() {
                return s(this, void 0, void 0, (function() {
                    return l(this, (function(e) {
                        return this.render(), [2]
                    }))
                }))
            }, e.prototype.render = function() {
                this.addCSS(this.bannerData),
                this.addHTML(this.bannerData),
                e.show(),
                this.setupCheckboxEventHandlers(),
                this.setupButtonEventHandlers(),
                this.setupKeyboardEventHandlers(),
                this.logger.emitInteraction(an.ManagePreferences)
            }, e.prototype.addCSS = function(e) {
                var n = _n(e),
                    t = po({
                        id: sn.StylesContainerId,
                        content: n
                    });
                document.head.appendChild(t)
            }, e.prototype.addHTML = function(n) {
                var t,
                    o,
                    r,
                    a = Co(n),
                    i = document.getElementById(cn.DialogId);
                o = a,
                null === (r = null == (t = i) ? void 0 : t.parentNode) || void 0 === r || r.insertBefore(o, t.nextSibling);
                var c = document.getElementById(sn.DialogId);
                c && (c.dataset.consent = e.selectedConsent()),
                e.hide()
            }, e.prototype.handleOptionChange = function(n) {
                var t = n.target,
                    o = n.isReadOnly,
                    r = n.sectionId;
                o && (t.checked = !0);
                var a,
                    i,
                    c,
                    s = t.checked,
                    l = document.getElementById(r),
                    u = l.querySelector('svg[data-icon-type="checked"]'),
                    d = l.querySelector('svg[data-icon-type="unchecked"]');
                s ? (u.style.display = "block", d.style.display = "none") : (u.style.display = "none", d.style.display = "block"),
                a = e.selectedConsent(),
                i = document.getElementById(sn.DialogId),
                c = document.getElementById(sn.HeaderSaveId),
                (null == i ? void 0 : i.dataset.consent) === a ? c.className = "" : c.className = "primary"
            }, e.prototype.setupCheckboxEventHandlers = function() {
                var e = this,
                    n = document.getElementById(sn.OptionEssentialInputId);
                null == n || n.addEventListener("change", (function(n) {
                    e.handleOptionChange({
                        target: n.target,
                        isReadOnly: !0,
                        sectionId: sn.OptionEssentialId
                    })
                }));
                var t = document.getElementById(sn.OptionAnalyticsInputId);
                null == t || t.addEventListener("change", (function(n) {
                    e.handleOptionChange({
                        target: n.target,
                        isReadOnly: !1,
                        sectionId: sn.OptionAnalyticsId
                    })
                }));
                var o = document.getElementById(sn.OptionPreferencesInputId);
                null == o || o.addEventListener("change", (function(n) {
                    e.handleOptionChange({
                        target: n.target,
                        isReadOnly: !1,
                        sectionId: sn.OptionPreferencesId
                    })
                }));
                var r = document.getElementById(sn.OptionMarketingInputId);
                null == r || r.addEventListener("change", (function(n) {
                    e.handleOptionChange({
                        target: n.target,
                        isReadOnly: !1,
                        sectionId: sn.OptionMarketingId
                    })
                }))
            }, e.prototype.setupButtonEventHandlers = function() {
                var n = this,
                    t = document.getElementById(sn.HeaderCloseId);
                null == t || t.addEventListener("click", (function() {
                    e.hide(),
                    n.logger.emitInteraction(an.LeavePreferences);
                    var t = document.getElementById(cn.ButtonManagePrefsId);
                    null == t || t.focus()
                })),
                null == t || t.focus();
                var o = document.getElementById(sn.HeaderSaveId);
                null == o || o.addEventListener("click", (function() {
                    if (In())
                        e.hideModalAndBanner();
                    else {
                        var t = document.getElementById(sn.OptionMarketingInputId),
                            o = document.getElementById(sn.OptionAnalyticsInputId),
                            r = document.getElementById(sn.OptionPreferencesInputId),
                            a = t.checked,
                            i = o.checked,
                            c = r.checked;
                        An({
                            marketing: a,
                            analytics: i,
                            preferences: c,
                            checkoutRootDomain: n.checkoutRootDomain,
                            storefrontRootDomain: n.storefrontRootDomain,
                            storefrontAccessToken: n.storefrontAccessToken,
                            callback: e.hideModalAndBanner
                        }),
                        n.logger.emitInteraction(an.Save, "".concat(a ? "m" : "").concat(i ? "a" : "").concat(c ? "p" : "")),
                        e.hideModalAndBanner()
                    }
                }));
                var r = document.getElementById(sn.HeaderAcceptId);
                null == r || r.addEventListener("click", (function() {
                    In() ? e.hideModalAndBanner() : (An({
                        marketing: !0,
                        analytics: !0,
                        preferences: !0,
                        checkoutRootDomain: n.checkoutRootDomain,
                        storefrontRootDomain: n.storefrontRootDomain,
                        storefrontAccessToken: n.storefrontAccessToken,
                        callback: e.hideModalAndBanner
                    }), n.logger.emitInteraction(an.AcceptedAll))
                }));
                var a = document.getElementById(sn.HeaderDeclineId);
                null == a || a.addEventListener("click", (function() {
                    In() ? e.hideModalAndBanner() : (An({
                        marketing: !1,
                        analytics: !1,
                        preferences: !1,
                        checkoutRootDomain: n.checkoutRootDomain,
                        storefrontRootDomain: n.storefrontRootDomain,
                        storefrontAccessToken: n.storefrontAccessToken,
                        callback: e.hideModalAndBanner
                    }), n.logger.emitInteraction(an.DeclinedAll))
                }))
            }, e.prototype.setupKeyboardEventHandlers = function() {
                var n = this,
                    t = document.getElementById(sn.WrapperId);
                null == t || t.addEventListener("keydown", (function(t) {
                    if (!t.defaultPrevented && "Escape" === t.code) {
                        e.hide(),
                        n.logger.emitInteraction(an.LeavePreferences);
                        var o = document.getElementById(cn.ButtonManagePrefsId);
                        null == o || o.focus()
                    }
                }))
            }, e
        }(),
        _o = function() {
            function e(e) {
                var n = void 0 === e ? {} : e,
                    t = n.shopDomain,
                    o = n.storefrontAccessToken,
                    r = n.checkoutRootDomain,
                    a = n.storefrontRootDomain;
                this.storefrontAccessToken = o;
                var i = t && o;
                i && (this.shopDomain = t, this.checkoutRootDomain = r, this.storefrontRootDomain = a),
                this.logger = new to({
                    shopDomain: t,
                    isHeadless: Boolean(i)
                })
            }
            return e.show = function() {
                var e = document.getElementById(cn.DialogId);
                null !== e && (e.style.display = "block");
                var n = document.getElementById(cn.ButtonManagePrefsId);
                null == n || n.focus()
            }, e.hide = function() {
                var e = document.getElementById(cn.DialogId);
                null !== e && (e.style.display = "none")
            }, e.prototype.init = function() {
                return s(this, void 0, void 0, (function() {
                    var e;
                    return l(this, (function(n) {
                        switch (n.label) {
                        case 0:
                            return this.removeExistingElements(), [4, Dn.getServerData(this.shopDomain, this.storefrontAccessToken)];
                        case 1:
                            return e = n.sent(), this.render(e), [2]
                        }
                    }))
                }))
            }, e.prototype.render = function(n) {
                if (In())
                    return n && Object.keys(n).length ? (this.addCSS(n), this.addBannerHTML(n), void e.show()) : void console.warn("banner not rendered due to lack of saved data");
                n && this.merchantHasPublished(n) && (this.addCSS(n), this.addBannerHTML(n), e.show(), this.logger.emitRender())
            }, e.prototype.addCSS = function(e) {
                var n = po({
                    id: cn.StylesContainerId,
                    content: En(e, !1)
                });
                document.head.appendChild(n)
            }, e.prototype.addBannerHTML = function(e) {
                var n = yo(e),
                    t = document.getElementsByTagName("body")[0];
                t.insertBefore(n, t.firstChild),
                this.addEventListeners(e)
            }, e.prototype.removeExistingElements = function() {
                var e,
                    n,
                    t = document.getElementById(cn.DialogId),
                    o = document.getElementById(cn.StylesContainerId);
                null === (e = null == t ? void 0 : t.parentNode) || void 0 === e || e.removeChild(t),
                null === (n = null == o ? void 0 : o.parentNode) || void 0 === n || n.removeChild(o)
            }, e.prototype.addEventListeners = function(e) {
                var n = this;
                this.addEssentialEventListeners(),
                In() || this.addMetricsEventListeners();
                var t = document.getElementById(cn.ButtonManagePrefsId);
                null == t || t.addEventListener("click", (function() {
                    n.preferencesModal = new bo({
                        bannerData: e,
                        shopDomain: n.shopDomain,
                        storefrontAccessToken: n.storefrontAccessToken,
                        checkoutRootDomain: n.checkoutRootDomain,
                        storefrontRootDomain: n.storefrontRootDomain
                    }),
                    n.preferencesModal.init()
                }))
            }, e.prototype.addEssentialEventListeners = function() {
                var n = this,
                    t = document.getElementById(cn.ButtonAcceptId);
                null == t || t.addEventListener("click", (function() {
                  document.cookie = "banner=1; expires=18 Dec 2024 12:00:00 UTC";
                    In() ? e.hide() : An({
                        marketing: !0,
                        analytics: !0,
                        preferences: !0,
                        checkoutRootDomain: n.checkoutRootDomain,
                        storefrontRootDomain: n.storefrontRootDomain,
                        storefrontAccessToken: n.storefrontAccessToken,
                        callback: e.hide
                    })
                }));
                var o = document.getElementById(cn.ButtonDeclineId);
                null == o || o.addEventListener("click", (function() {
                    In() ? e.hide() : An({
                        marketing: !1,
                        analytics: !1,
                        preferences: !1,
                        checkoutRootDomain: n.checkoutRootDomain,
                        storefrontRootDomain: n.storefrontRootDomain,
                        storefrontAccessToken: n.storefrontAccessToken,
                        callback: e.hide
                    })
                }))
            }, e.prototype.addMetricsEventListeners = function() {
                var e = this,
                    n = document.getElementById(cn.BodyCopyPolicyLinkId);
                null == n || n.addEventListener("click", (function() {
                    e.logger.emitInteraction(an.PrivacyPolicyView)
                }));
                var t = document.getElementById(cn.ButtonAcceptId);
                null == t || t.addEventListener("click", (function() {
                    e.logger.emitInteraction(an.Accepted)
                }));
                var o = document.getElementById(cn.ButtonDeclineId);
                null == o || o.addEventListener("click", (function() {
                    e.logger.emitInteraction(an.Declined)
                }))
            }, e.prototype.merchantHasPublished = function(e) {
                return !0 === (null == e ? void 0 : e.enabled)
            }, e
        }();
    function Eo(e) {
        var n = void 0 === e ? {} : e,
            t = n.shopDomain,
            o = n.storefrontAccessToken,
            r = n.checkoutRootDomain,
            a = n.storefrontRootDomain;
        return s(this, void 0, void 0, (function() {
            var e,
                n,
                i;
            return l(this, (function(c) {
                return r || (r = window.location.hostname), a || (a = window.location.hostname), e = function() {
                    (In() || function() {
                        var e,
                            n,
                            t,
                            o,
                            r;
                        return (null === (n = null === (e = window.Shopify) || void 0 === e ? void 0 : e.customerPrivacy) || void 0 === n ? void 0 : n.doesMerchantSupportGranularConsent()) ? xn() && (null === (r = null === (o = null === (t = window.Shopify) || void 0 === t ? void 0 : t.customerPrivacy) || void 0 === o ? void 0 : o.unstable) || void 0 === r ? void 0 : r.shouldShowBanner()) : xn() && void 0 !== window.Shopify && void 0 !== window.Shopify.customerPrivacy && "GDPR" === window.Shopify.customerPrivacy.getRegulation() && window.Shopify.customerPrivacy.isRegulationEnforced() && "no_interaction" === window.Shopify.customerPrivacy.getTrackingConsent()
                    }()) && new _o({
                        shopDomain: t,
                        storefrontAccessToken: o,
                        checkoutRootDomain: r,
                        storefrontRootDomain: a
                    }).init()
                }, t && o ? (n = window.Shopify.customerPrivacy.currentVisitorConsent(), An({
                    marketing: (i = {
                        yes: !0,
                        no: !1
                    })[n.marketing],
                    analytics: i[n.analytics],
                    preferences: i[n.preferences],
                    sale_of_data: i[n.sale_of_data],
                    storefrontAccessToken: o,
                    checkoutRootDomain: r,
                    storefrontRootDomain: a,
                    callback: e
                })) : e(), [2]
            }))
        }))
    }
    return function() {
        var e = Boolean(window.Shopify);
        window.Shopify = window.Shopify || {};
        var n = function() {
            e && Eo()
        };
        window.Shopify.customerPrivacy && window.Shopify.trackingConsent || (window.Shopify.customerPrivacy = rn(), window.Shopify.trackingConsent = rn()),
        n()
    }(), e.loadBanner = Eo, e
  }}({});
